<template>
  <div v-if="orderDrawer">
    <a-drawer
      :visible="orderDrawer"
      class="authAccount"
      title="订单详情"
      width="1200px"
      placement="right"
      @close="closeOrderDrawer"
      :bodyStyle="{ overflow: 'auto', height: 'calc(100% - 161px)' }"
    >
      <a-spin :spinning="spinning_detail" tip="加载中...">
        <div class="searchResult">
          <span class="name">{{ order_detail.name }}


            <a-popover
              ref="namePopover"
              title="设置名称"
              placement="bottom"
              trigger="click"
              :getPopupContainer="
                (triggerNode) => {
                  return triggerNode.parentNode || document.body;
                }
              "
            >
              <template slot="content">
                <p>
                  <a-input
                    placeholder="设置名称"
                    v-model="editname"
                    style="width: 100%"
                  />
                </p>
                <p>
                  <a-button
                    type="primary"
                    icon="edit"
                    style="width: 100%; margin-top: 5px"
                    @click="setAdName(order_detail)"
                    >设置备注</a-button
                  >
                </p>
              </template>
              <a-icon type="edit" @click="editname=order_detail.name" style="cursor: pointer"/>
            </a-popover>

          </span>
          <div class="tags-container">
            <span class="info-item">千川户ID：{{ advertiser_id }}</span>
            <span
              class="ad-tag tag green"
              v-if="order_detail.status == 'DELIVERY_OK'"
              >投放中</span
            >
            <span class="ad-tag tag red" v-else>
              {{ getStatusName(order_detail.status) }}</span
            >
            <span class="ad-tag tag">千川计划ID: {{ order_detail.ad_id }}</span>
            <span class="ad-tag tag red">预算：{{ adlist?.[0]?.ad_info?.budget }}
              <a-popover
                ref="budgetPopover"
                title="修改预算"
                placement="bottom"
                trigger="click"
                :getPopupContainer="
                  (triggerNode) => {
                    return triggerNode.parentNode || document.body;
                  }
                "
              >
                <template slot="content">
                  <p>
                    <a-input-number
                      placeholder="设置预算"
                      v-model="editBudget"
                      :min="0"
                      :precision="2"
                      style="width: 200px"
                    />
                  </p>
                  <p>
                    <a-button
                      type="primary"
                      icon="edit"
                      style="width: 100%; margin-top: 5px"
                      :loading="budgetLoading"
                      @click="updateBudget(adlist?.[0]?.ad_info?.budget)"
                      >确认修改</a-button
                    >
                  </p>
                </template>
                <a-icon 
                  type="edit" 
                  @click="editBudget = adlist?.[0]?.ad_info?.budget" 
                  style="cursor: pointer; margin-left: 5px"
                />
              </a-popover>
            </span>
            <span class="ad-tag tag red">ROI 目标：{{ adlist?.[0]?.ad_info?.roi2_goal }}
              <a-popover
                ref="roiPopover"
                title="修改 ROI 目标"
                placement="bottom"
                trigger="click"
                :getPopupContainer="
                  (triggerNode) => {
                    return triggerNode.parentNode || document.body;
                  }
                "
                @visibleChange="onDetailRoiPopoverVisibleChange"
              >
                <template slot="content">
                  <p class="roi-popover-last-modify-line">
                    <template v-if="roiLastModify.loading">
                      <a-icon type="loading" spin />
                      <span class="roi-popover-last-modify-loading"
                        >获取修改时间…</span
                      >
                    </template>
                    <span
                      v-else-if="roiLastModify.error"
                      class="roi-popover-last-modify--error"
                      >{{ roiLastModify.error }}</span
                    >
                    <template v-else>
                      距离上次修改
                      <span :class="detailRoiLastModifyValueClass">{{
                        formatDetailRoiLastModifyHours
                      }}</span>
                      小时
                    </template>
                  </p>
                  <p>
                    <a-input-number
                      placeholder="设置 ROI 目标"
                      v-model="editRoiGoal"
                      :min="0"
                      :precision="2"
                      :step="0.1"
                      style="width: 200px"
                    />
                  </p>
                  <p>
                    <a-button
                      type="primary"
                      icon="edit"
                      style="width: 100%; margin-top: 5px"
                      :loading="roiLoading"
                      @click="updateRoiGoal(adlist?.[0]?.ad_info?.roi2_goal)"
                      >确认修改</a-button
                    >
                  </p>
                </template>
                <a-icon
                  type="edit"
                  @click="onDetailRoiEditIconClick"
                  style="cursor: pointer; margin-left: 5px"
                />
              </a-popover>
            </span>
          </div>
          <div
            class="ad-drawer__aweme-info"
            v-if="
              ad.product_info[0].product_image &&
              order_detail.marketing_goal == 'VIDEO_PROM_GOODS'
            "
          >
            <div class="product-item">
              <div class="byted-popover-wrapper">
                <div class="good">
                  <img
                    :src="ad.product_info[0].product_image"
                    alt="商品图片"
                    class="icon"
                  />
                </div>
              </div>
              <div class="info">
                <p class="name">
                  {{ ad.product_info[0].product_name }}
                </p>
                <span class="id"
                  >商品ID {{ ad.product_info[0].product_id }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <a-tabs
          :default-active-key="detailTab"
          @change="changeDetailTopTab"
          :tabBarStyle="{
            display: 'flex',
            justifyContent: 'flex-start',
            position: 'relative',
          }"
        >
          <a-tab-pane tab="概览" key="1">
            <div class="title">
              数据概览
              <a-range-picker
                :ranges="{
                  今日: [moment(), moment()],
                  昨日: [
                    moment().subtract(1, 'days'),
                    moment().subtract(1, 'days'),
                  ],
                  本周: [moment().startOf('week'), moment()],
                  上周: [
                    moment().subtract(1, 'week').startOf('week'),
                    moment().subtract(1, 'week').endOf('week'),
                  ],
                  本月: [moment().startOf('month'), moment()],
                  上月: [
                    moment().subtract(1, 'month').startOf('month'),
                    moment().subtract(1, 'month').endOf('month'),
                  ],
                }"
                style="width: 240px; margin-left: 10px"
                :value="ad_range_date"
                @change="onAdTimeChange"
                class="filterItem"
                showToday
                :placeholder="['开始时间', '结束时间']"
              />
              <a-button
                class="btn"
                :loading="spinning"
                type="primary"
                @click="getData"
                icon="sync"
              ></a-button>
            </div>
            <div class="board-list">
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">消耗(元)</p>
                  <p class="value">{{ adlist?.[0]?.stats_info?.stat_cost }}</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">整体支付ROI</p>
                  <p class="value">
                    {{
                      adlist?.[0]?.stats_info?.total_prepay_and_pay_order_roi2
                    }}
                  </p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">整体成交金额</p>
                  <p class="value">
                    {{ adlist?.[0]?.stats_info?.total_pay_order_gmv_for_roi2 }}
                  </p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">整体成交订单数</p>
                  <p class="value">
                    {{
                      adlist?.[0]?.stats_info?.total_pay_order_count_for_roi2
                    }}
                  </p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">整体成交订单成本</p>
                  <p class="value">
                    {{
                      adlist?.[0]?.stats_info?.total_cost_per_pay_order_for_roi2
                    }}
                  </p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">智能优惠券金额</p>
                  <p class="value">
                    {{
                      adlist?.[0]?.stats_info
                        ?.total_pay_order_coupon_amount_for_roi2
                    }}
                  </p>
                </div>
              </div>

              <div class="overview-board" style="display: none;">
                <div class="inner">
                  <p class="metric">未完结预售订单金额</p>
                  <p class="value">
                    {{
                      adlist?.[0]?.stats_info
                        ?.total_unfinished_estimate_order_gmv_for_roi2
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="title">联盟订单</div>
            <div class="board-list">
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">实际利润</p>
                  <p class="value">
                    {{ adlist?.[0]?.stats_info?.all_profit }} 元
                  </p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">利润百分比</p>
                  <p class="value">
                    {{ adlist?.[0]?.stats_info?.all_profit_rate }} %
                  </p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">联盟退货率</p>
                  <p class="value">
                    {{ adlist?.[0]?.stats_info?.all_refund_rate }} %
                  </p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">联盟全部销售额</p>
                  <p class="value">
                    {{ adlist?.[0]?.stats_info?.all_total_pay_amount_str }}
                  </p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">联盟全部订单</p>
                  <p class="value">
                    {{ adlist?.[0]?.stats_info?.all_total_count }}
                  </p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">联盟全部佣金</p>
                  <p class="value">
                    {{
                      adlist?.[0]?.stats_info
                        ?.all_estimated_total_commission_str
                    }}
                  </p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">联盟有效销售额</p>
                  <p class="value">
                    {{
                      adlist?.[0]?.stats_info?.all_valid_total_pay_amount_str
                    }}
                  </p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">联盟有效订单</p>
                  <p class="value">
                    {{ adlist?.[0]?.stats_info?.all_valid_count }}
                  </p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">联盟有效佣金</p>
                  <p class="value">
                    {{
                      adlist?.[0]?.stats_info
                        ?.all_valid_estimated_total_commission_str
                    }}
                  </p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">联盟退款销售额</p>
                  <p class="value">
                    {{
                      adlist?.[0]?.stats_info?.all_refund_total_pay_amount_str
                    }}
                  </p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">联盟退款订单</p>
                  <p class="value">
                    {{ adlist?.[0]?.stats_info?.all_refund_count }}
                  </p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">联盟退款佣金</p>
                  <p class="value">
                    {{
                      adlist?.[0]?.stats_info
                        ?.all_refund_estimated_total_commission_str
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="title">数据趋势</div>
            <div>
              <div class="yAxis">
                <div>
                  <section class="yAxis1" />
                  <a-select
                    v-model="adlineChartData.yAxis1"
                    style="width: 150px"
                    placeholder="请选择"
                    @change="adchangeAxis1"
                  >
                    <a-select-option
                      v-for="item in adyAxis1options"
                      :key="item.value"
                      :value="item.value"
                      :disabled="item.disabled"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </div>
                <div>
                  <section class="yAxis2" />
                  <a-select
                    v-model="adlineChartData.yAxis2"
                    style="width: 150px"
                    placeholder="请选择"
                    @change="adchangeAxis2"
                  >
                    <a-select-option
                      v-for="item in adyAxis2options"
                      :key="item.value"
                      :value="item.value"
                      :disabled="item.disabled"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
              <a-spin :spinning="adloading" tip="加载中...">
                <line-chart :chart-data="adlineChartData" />
              </a-spin>
              
            </div>

            <div class="title">详细数据</div>
            <div class="board-list">
              <a-table
                  ref="inOrderTable"
                  :columns="adcolumns"
                  :data-source="adtableData"
                  :pagination="false"
                  :scroll="{ y: 400 }"
                  :rowKey="(record) => record.id || record.ad_id"
                >
                </a-table>
            </div>

          </a-tab-pane>
          <a-tab-pane tab="商品" key="8">
            <div class="row">
              <a-input-search
                v-model="product_search_keyword"
                :allowClear="true"
                style="margin-left: 10px; width: 180px"
                placeholder="输入商品名称/ID"
                enter-button
                @search="getAdProduct"
              />

              <a-select
                v-model="product_status"
                style="width: 100px; margin-left: 10px"
                @change="handleProductStatusChange"
              >
                <a-select-option value="ALL">全部</a-select-option>
                <a-select-option value="DELIVERY_OK">投放中</a-select-option>
                <a-select-option value="DELETED">已删除</a-select-option>
                <a-select-option value="AUDIT_PASS">审核通过</a-select-option>
                <a-select-option value="AUDIT_REJECT">审核拒绝</a-select-option>
                <a-select-option value="AUDIT_IN_PROGRESS">审核中</a-select-option>
              </a-select>

              <a-range-picker
                style="width: 240px; margin-left: 10px"
                :value="range_date"
                @change="onProductTimeChange"
                class="filterItem"
                showToday
                :placeholder="['开始时间', '结束时间']"
              />

              <a-button
                class="btn"
                type="primary"
                @click="addProductAction"
                icon="plus" 
                >补商品</a-button
              >
              <a-button
                class="btn"
                type="danger"
                icon="delete"
                style="margin-left: 10px"
                :disabled="selectedProductRowKeys.length === 0"
                @click="batchDeleteProduct"
                >删商品</a-button
              >
            </div>
            <div class="board-list">
              <a-table
                style="width: 100%"
                :columns="product_columns"
                :pagination="product_pagination"
                :data-source="product_data"
                :rowKey="
                  (record, index) => {
                    return index;
                  }
                "
                :sortDirections="['descend', 'ascend', '']"
                @change="handleProductTableChange"
                :scroll="{ x: 1200, y: 'calc(56vh)' }"
                :rowSelection="{
                  selectedRowKeys: selectedProductRowKeys,
                  onChange: onProductSelectChange,
                }"
              >
                <div class="product-info" slot="product_info" slot-scope="text">
                  <div class="product-left">
                    <img
                      v-if="text?.product_info?.product_image"
                      :src="text.product_info.product_image"
                      style="width: 50px; height: 50px; border-radius: 4px; object-fit: cover"
                      alt="商品图片"
                    />
                    <div
                      v-else
                      style="width: 50px; height: 50px; border-radius: 4px; background: #f5f5f5; display: flex; align-items: center; justify-content: center; color: #999;"
                    >
                      无图
                    </div>
                  </div>
                  <div class="product-right">
                    <a-tooltip
                      placement="top"
                      :title="text?.product_info?.product_name"
                    >
                      <div class="product-title">
                        {{ text?.product_info?.product_name || '未知商品' }}
                      </div>
                    </a-tooltip>
                    <div class="product-id small">
                      商品ID：{{ text?.product_info?.product_id }}
                      <a-icon
                        type="copy"
                        @click="text_copy(text?.product_info?.product_id)"
                        style="margin-left: 5px; cursor: pointer;"
                      />
                    </div>
                    <div class="product-id small">
                      审核状态：
                      <a-tag
                        :color="text?.product_info?.audit_status == 'PASS' ? 'green' : 
                               text?.product_info?.audit_status == 'REJECT' ? 'red' : 
                               text?.product_info?.audit_status == 'IN_PROGRESS' ? 'orange' : 'default'"
                        size="small"
                      >
                        {{ text?.product_info?.audit_status == 'PASS' ? '审核通过' : 
                           text?.product_info?.audit_status == 'REJECT' ? '审核拒绝' : 
                           text?.product_info?.audit_status == 'IN_PROGRESS' ? '审核中' : '未知' }}
                      </a-tag>
                    </div>
                  </div>
                </div>

                <div slot="product_status" slot-scope="text">
                  <a-tag
                    color="green"
                    v-if="!text?.is_del && text?.product_info?.audit_status == 'PASS'"
                    >投放中</a-tag
                  >
                  <a-tag
                    color="red"
                    v-else-if="text?.is_del"
                    >已删除</a-tag
                  >
                  <a-tag
                    color="orange"
                    v-else-if="text?.product_info?.audit_status == 'IN_PROGRESS'"
                    >审核中</a-tag
                  >
                  <a-tag
                    color="red"
                    v-else-if="text?.product_info?.audit_status == 'REJECT'"
                    >审核拒绝</a-tag
                  >
                  <a-tag
                    color="default"
                    v-else
                    >未知状态</a-tag
                  >
                </div>
                <div
                  style="cursor: pointer; text-align: center"
                  slot="product_action"
                  slot-scope="text, record"
                >
                  <span
                    slot="action"
                    v-if="!text?.is_del"
                    class="actionItem"
                    @click="deleteProduct(record)"
                    style="color: red"
                    >删除</span
                  >
                </div>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="创意" key="2">
            <div class="row">
              <a-radio-group
                :value="material_type"
                @change="handleMaterialTypeChange"
              >
                <a-radio-button value="VIDEO"> 视频 </a-radio-button>
                <a-radio-button
                  value="IMAGE"
                  v-if="order_detail.marketing_goal == 'VIDEO_PROM_GOODS'"
                >
                  图片
                </a-radio-button>
                <a-radio-button
                  value="LIVE_ROOM"
                  v-if="order_detail.marketing_goal == 'LIVE_PROM_GOODS'"
                >
                  直播间画面
                </a-radio-button>
                <a-radio-button value="TITLE"> 标题 </a-radio-button>
              </a-radio-group>

              <a-input-search
                v-model="search_keyword"
                :allowClear="true"
                style="margin-left: 10px; width: 180px"
                placeholder="输入视频名称/ID"
                enter-button
                @search="getAdMaterial"
              />

              <a-select
                v-model="material_status"
                style="width: 80px; margin-left: 10px"
                @change="handleStatusChange"
              >
                <a-select-option value="ALL">全部</a-select-option>
                <a-select-option value="DELIVERY_OK">投放中</a-select-option>
                <a-select-option value="DELETED">已删除</a-select-option>
              </a-select>

              <a-select
                class="filterItem"
                v-model="analysis_type"
                :maxTagCount="1"
                style="width: 100px; margin-left: 10px"
                placeholder="素材评估"
                @change="handleAnalysisChange"
              >
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="FIRST_PUBLISH_MATERIAL"
                  >首发素材</a-select-option
                >
                <a-select-option value="HIGH_QUALITY_MATERIAL"
                  >优质素材</a-select-option
                >
                <a-select-option value="LOW_QUALITY_MATERIAL"
                  >低质素材</a-select-option
                >
                <a-select-option value="INEFFICIENT_MATERIAL"
                  >低效素材</a-select-option
                >
                <a-select-option value="CARRY_MATERIAL"
                  >搬运素材</a-select-option
                >
                <a-select-option value="SIMILAR_MATERIAL"
                  >同质化素材</a-select-option
                >
                <a-select-option value="MATERIAL_SUGGEST"
                  >审核建议</a-select-option
                >
              </a-select>

              <a-range-picker
                style="width: 240px; margin-left: 10px"
                :value="range_date"
                @change="onTimeChange"
                class="filterItem"
                showToday
                :placeholder="['开始时间', '结束时间']"
              />

              <a-button
                class="btn"
                type="primary"
                @click="addMaterial"
                icon="plus"
                v-if="material_type == 'VIDEO'"
                >补素材</a-button
              >
              <a-button
                class="btn"
                type="primary"
                :disabled="true"
                icon="plus"
                v-if="material_type == 'TITLE'"
                >补标题</a-button
              >
              <a-button
                class="btn"
                type="danger"
                icon="delete"
                style="margin-left: 10px"
                :disabled="selectedRowKeys.length === 0"
                @click="batchDeleteMaterial"
                >删创意</a-button
              >
              <a-button
                class="btn"
                type="primary"
                icon="plus"
                style="margin-left: 10px"
                :disabled="!canBatchFission"
                @click="batchFissionMaterial"
                >裂变</a-button
              >
            </div>
            <div class="board-list">
              <a-table
                style="width: 100%"
                :columns="material_columns"
                :pagination="pagination"
                :data-source="material_data"
                :rowKey="
                  (record, index) => {
                    return index;
                  }
                "
                :sortDirections="['descend', 'ascend', '']"
                @change="handleTableChange"
                :scroll="{ x: 1200, y: 'calc(56vh)' }"
                :rowSelection="{
                  selectedRowKeys: selectedRowKeys,
                  onChange: onSelectChange,
                  getCheckboxProps: (record) => ({
                    disabled: !record || !record.stat_cost_for_roi2 || record.stat_cost_for_roi2 <= 10,
                  }),
                }"
              >
                <div class="aweme" slot="info" slot-scope="text">
                  <div
                    class="aweme-left"
                    v-if="
                      text?.material_info?.video_material?.cover_image
                        ?.image_url ||
                      text?.material_info?.image_material?.image_url
                    "
                  >
                    <a-popover
                      placement="right"
                      :overlayStyle="{
                        padding: '0',
                        minWidth: '220px',
                        maxWidth: '320px',
                      }"
                    >
                      <template slot="content">
                        <video
                          v-if="text?.material_info?.video_material?.url"
                          :src="text.material_info.video_material.url"
                          style="height: 520px; display: block"
                          autoplay
                          muted
                          loop
                          controls
                        ></video>
                      </template>
                      <img
                        class="videoimg"
                        :src="
                          text?.material_info?.video_material?.cover_image
                            ?.image_url ||
                          text?.material_info?.image_material?.image_url
                        "
                        style="width: 40px; height: 50px"
                      />
                    </a-popover>
                  </div>
                  <div class="aweme-right">
                    <a-tooltip
                      placement="top"
                      :title="
                        text?.material_info?.video_material?.title ||
                        text?.material_info?.title_material?.title
                      "
                    >
                      <div class="aweme-title">
                        {{
                          text?.material_info?.video_material?.title ||
                          text?.material_info?.title_material?.title
                        }}
                      </div>
                    </a-tooltip>
                    <div class="aweme-id small">
                      素材ID：{{ text?.material_id }}
                      <a-icon
                        type="copy"
                        @click="text_copy(text?.material_id)"
                      />
                    </div>
                    <div class="aweme-id small">
                      <span
                        v-if="text?.material_select_type == 'CUSTOM'"
                        style="color: #52c41a"
                        >自选投放素材</span
                      >
                      <span v-if="text?.material_select_type == 'AUTO'"
                        >智能优选素材</span
                      >

                      <!-- <a-tooltip placement="top" :title="text.audit_reason	">
                      <span style="color: red;" v-if="text.audit_reason">
                        审核建议
                      </span>
                    </a-tooltip> -->

                      <a-popover
                        placement="right"
                        trigger="hover"
                        :overlayStyle="{
                          padding: '0',
                          minWidth: '220px',
                          maxWidth: '320px',
                        }"
                      >
                        <template slot="content">
                          <div
                            v-for="(tx, index) in text.audit_reason"
                            :key="index"
                          >
                            <!-- {{tx}} -->
                            <p v-html="tx"></p>
                          </div>
                        </template>
                        <b
                          style="color: red; cursor: pointer"
                          v-if="text.audit_reason"
                        >
                          审核建议
                        </b>
                      </a-popover>
                    </div>
                  </div>
                </div>

                <div slot="material" slot-scope="text">
                  <a-tag
                    color="green"
                    v-if="text?.material_status == 'DELIVERY_OK'"
                    >投放中</a-tag
                  >
                  <a-tag
                    color="red"
                    v-else-if="text?.material_status == 'DELETED'"
                    >已删除</a-tag
                  >
                </div>
                <div slot="status" slot-scope="text">
                  <a-tag color="green" v-if="text?.audit_status == 'PASS'"
                    >审核通过</a-tag
                  >
                  <a-tag color="red" v-else-if="text?.audit_status == 'REJECT'"
                    >审核拒绝</a-tag
                  >
                  <a-tag
                    color=""
                    v-else-if="text?.audit_status == 'IN_PROGRESS'"
                    >审核中</a-tag
                  >
                </div>
                <div
                  style="cursor: pointer; text-align: center"
                  slot="action"
                  slot-scope="text, record"
                >
                  <span
                    slot="action"
                    v-if="!text?.is_del && (text?.stat_cost_for_roi2 > 5)"
                    class="actionItem"
                    @click="fissionMaterial(record)"
                    style="color: green;margin-right: 10px;"
                    >裂变</span
                  >
                  <!-- <span
                    slot="action"
                    v-if="!text?.is_del"
                    class="actionItem"
                    @click="fissionMaterial(record)"
                    style="color: green;margin-right: 10px;"
                    >裂变</span
                  > -->
                  <span
                    slot="action"
                    v-if="text?.material_status != 'DELETED'"
                    class="actionItem"
                    @click="deleteMaterial(record)"
                    style="color: red"
                    >删除</span
                  >
                </div>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="详情" key="3">
            <!-- <div class="title">详情</div> -->
            <div class="oc-detail-bar">
              <div class="oc-detail-bar-text">
                <div class="oc-detail-bar-config-item">
                  营销目标：{{
                    order_detail.marketing_goal == 'VIDEO_PROM_GOODS'
                      ? '推商品'
                      : '推直播'
                  }}
                </div>
                <div class="oc-detail-bar-config-item">
                  推广方式：{{
                    ad.ad_info.smart_bid_type == 'SMART_BID_CUSTOM'
                      ? '控成本投放'
                      : '放量投放'
                  }}
                </div>
              </div>
            </div>

            <div class="config-card-container" style="column-count: 1">
              <div class="oc-promotion-detail-card config-card">
                <div class="oc-promotion-detail-card-header">投放设置</div>
                <div class="oc-promotion-detail-card-body">
                  <div class="oc-promotion-detail-card-body-item">
                    <span
                      >投放方式：{{
                        order_detail?.delivery_setting?.smart_bid_type ==
                        'SMART_BID_CUSTOM'
                          ? '控成本投放'
                          : '放量投放'
                      }}</span
                    >
                  </div>
                  <div class="oc-promotion-detail-card-body-item">
                    <span>优化目标：整体支付ROI</span>
                  </div>

                  <div class="oc-promotion-detail-card-body-item">
                    <span
                      >{{
                        order_detail?.delivery_setting?.budget_mode ==
                        'BUDGET_MODE_DAY'
                          ? '日预算'
                          : '总预算'
                      }}：{{ order_detail?.delivery_setting?.budget }} 元</span
                    >
                  </div>

                  <div class="oc-promotion-detail-card-body-item">
                    <span
                      >智能优惠券：{{
                        order_detail?.delivery_setting?.qcpx_mode ==
                        'QCPX_MODE_ON'
                          ? '启用'
                          : '不启用'
                      }}</span
                    >
                  </div>

                  <div
                    class="oc-promotion-detail-card-body-item"
                    v-if="order_detail?.delivery_setting?.cpa_bid"
                  >
                    <span
                      >出价：{{ order_detail?.delivery_setting?.cpa_bid }}</span
                    >
                  </div>
                  <div
                    class="oc-promotion-detail-card-body-item"
                    v-if="order_detail?.delivery_setting?.roi2_goal"
                  >
                    <span
                      >ROI目标：{{
                        order_detail?.delivery_setting?.roi2_goal
                      }}</span
                    >
                  </div>

                  <div
                    class="oc-promotion-detail-card-body-item"
                    v-if="order_detail.marketing_goal == 'VIDEO_PROM_GOODS'"
                  >
                    <span
                      >投放时间：{{
                        order_detail?.delivery_setting?.video_schedule_type ==
                        'SCHEDULE_FROM_NOW'
                          ? '从今天起长期投放'
                          : '设置开始和结束日期'
                      }}</span
                    >
                  </div>
                  <div
                    class="oc-promotion-detail-card-body-item"
                    v-if="order_detail.marketing_goal == 'LIVE_PROM_GOODS'"
                  >
                    <span
                      >投放时间：{{
                        get_live_schedule_type(
                          order_detail?.delivery_setting?.live_schedule_type
                        )
                      }}</span
                    >
                  </div>
                  <div
                    class="oc-promotion-detail-card-body-item"
                    v-if="
                      order_detail?.delivery_setting?.video_schedule_type ==
                        'SCHEDULE_START_END' ||
                      order_detail?.delivery_setting?.live_schedule_type ==
                        'SCHEDULE_START_END'
                    "
                  >
                    <span
                      >投放时段：{{
                        order_detail?.delivery_setting?.start_time
                      }}
                      ~ {{ order_detail?.delivery_setting?.end_time }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="日志" key="4">
            <!-- <div class="title">日志</div> -->
            <div class="board-list">
              <a-table
                style="width: 100%"
                :columns="log_columns"
                :data-source="log_data"
                :pagination="ad_log_pagination"
                :rowKey="(record, index) => record.log_id || `log-${index}`"
                @change="handleAdLogTableChange"
              >
                <div slot="content" slot-scope="text">
                  <p v-for="(item, index) in text.content_log" :key="index">
                    {{ item }}
                  </p>
                </div>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="诊断" key="5">
            <!-- <div class="title">诊断</div> -->
            <div class="board-list"></div>
          </a-tab-pane>
          <a-tab-pane tab="操作日志" key="6">
            <a-table
              style="width: 100%"
              :columns="user_log_columns"
              :data-source="user_log_data"
              :rowKey="
                (record, index) => {
                  return index;
                }
              "
            >
            </a-table>
          </a-tab-pane>
          <a-tab-pane tab="监控日志" key="7">
            <a-table
              style="width: 100%"
              :columns="monitor_log_columns"
              :data-source="monitor_log_data"
              :rowKey="
                (record, index) => {
                  return index;
                }
              "
            >
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </a-spin>

      <div class="footer">
        <!-- <a-button type="primary" @click="copyOneAd(ad)">复制计划</a-button> -->
      </div>
    </a-drawer>

    <addVideo
      v-if="videoVisible"
      :advertiser_id="advertiser_id"
      :marketing_goal="order_detail.marketing_goal"
      :aweme_id="order_detail.aweme_id + ''"
      :product_list="product_list"
      :newSelectList="newSelectList"
      @receive="videoreceive"
      @closeAddDrawer="closeAddDrawer"
    />

    <a-modal
      title="提示"
      :visible="resultvisible"
      :footer="null"
      width="700px"
      @cancel="resultvisible = false"
    >
      <a-result
        status="success"
        title="您的任务已创建成功!"
        sub-title="请前往【千川全域】-》【任务管理】,查看任务具体执行进度。"
      >
        <template #extra>
          <a-button key="console" type="primary" @click="resultvisible = false">
            关闭弹窗
          </a-button>
          <a-button key="buy" @click="gotask"> 前往任务列表 </a-button>
        </template>
      </a-result>

      <br />
      <br />
    </a-modal>

    <a-modal
      title="追加创意标题（每行一个，支持换行）"
      :visible="titleModalVisible"
      :z-index="1000001"
      @ok="addMaterialAction"
      :confirm-loading="addloading"
      @cancel="titleModalVisible = false"
      :okText="'确定补' + select_list.length + '条素材'"
    >
      <a-textarea
        v-model="titleInput"
        :rows="4"
        placeholder="每行一个标题，支持换行"
        @input="handleTitleInput"
      />
      <div v-if="titleList.length" style="margin-top: 16px">
        <div
          v-for="(title, idx) in titleList"
          :key="idx"
          style="display: flex; align-items: center; margin-bottom: 8px"
        >
          <span style="flex: 1">{{ title }}</span>
          <a-icon
            type="delete"
            style="color: red; cursor: pointer"
            @click="removeTitle(idx)"
          />
        </div>
      </div>
    </a-modal>

    <!-- 补商品抽屉 -->
    <a-drawer
      title="可投商品列表"
      width="1200px"
      :visible="addProductDrawerVisible"
      placement="right"
      @close="closeAddProductDrawer"
    >
      <div class="searchWapper">
        <a-form-model layout="inline">
          <a-form-model-item label="商品ID">
            <a-input
              v-model="add_product_search_ids"
              placeholder="输入商品ID"
              :allowClear="true"
              @change="searchAddProductList"
              style="width: 140px"
            />
          </a-form-model-item>
          <a-form-model-item label="商品名称">
            <a-input
              v-model="add_product_search_name"
              placeholder="输入商品名称"
              :allowClear="true"
              @change="searchAddProductList"
              style="width: 140px"
            />
          </a-form-model-item>
          <a-form-model-item label="">
            <a-button
              type="primary"
              icon="search"
              style="margin-right: 5px"
              @click="searchAddProductList"
            >
              搜索</a-button
            >
            <a-button
              icon="filter"
              type="default"
              @click="showAddProductFilterModal"
              :loading="add_product_loading"
              style="margin-left: 8px;"
            ></a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <!-- 筛选弹窗 -->
      <a-modal
        title="商品筛选"
        :visible="add_product_filterModalVisible"
        @ok="applyAddProductFilter"
        @cancel="cancelAddProductFilter"
        :width="800"
        :footer="null"
      >
        <div class="filter-container">
          <!-- 售价区间 -->
          <div class="filter-section">
            <div class="filter-header" @click="toggleAddProductPriceSection">
              <span class="filter-title">售价区间</span>
              <a-icon :type="add_product_priceSectionExpanded ? 'up' : 'down'" />
            </div>
            <div v-show="add_product_priceSectionExpanded" class="filter-content">
              <div class="range-options">
                <div
                  v-for="range in add_product_priceRanges"
                  :key="range.value"
                  class="range-option"
                  :class="{ active: add_product_selectedPriceRange === range.value }"
                  @click="selectAddProductPriceRange(range.value)"
                >
                  {{ range.label }}
                </div>
              </div>
              <div class="custom-range">
                <div class="custom-inputs">
                  <a-input
                    v-model="add_product_priceRange.min"
                    placeholder="最低价"
                    style="width: 120px;"
                  >
                    <template slot="suffix">元</template>
                  </a-input>
                  <span class="separator">-</span>
                  <a-input
                    v-model="add_product_priceRange.max"
                    placeholder="最高价"
                    style="width: 120px;"
                  >
                    <template slot="suffix">元</template>
                  </a-input>
                </div>
              </div>
            </div>
          </div>

          <!-- 佣金区间 -->
          <div class="filter-section">
            <div class="filter-header" @click="toggleAddProductCommissionSection">
              <span class="filter-title">佣金区间</span>
              <a-icon :type="add_product_commissionSectionExpanded ? 'up' : 'down'" />
            </div>
            <div v-show="add_product_commissionSectionExpanded" class="filter-content">
              <div class="range-options">
                <div
                  v-for="range in add_product_commissionRanges"
                  :key="range.value"
                  class="range-option"
                  :class="{ active: add_product_selectedCommissionRange === range.value }"
                  @click="selectAddProductCommissionRange(range.value)"
                >
                  {{ range.label }}
                </div>
              </div>
              <div class="custom-range">
                <div class="custom-inputs">
                  <a-input
                    v-model="add_product_commissionRange.min"
                    placeholder="最低值"
                    style="width: 120px;"
                  >
                    <template slot="suffix">%</template>
                  </a-input>
                  <span class="separator">-</span>
                  <a-input
                    v-model="add_product_commissionRange.max"
                    placeholder="最高值"
                    style="width: 120px;"
                  >
                    <template slot="suffix">%</template>
                  </a-input>
                </div>
              </div>
            </div>
          </div>

          <!-- 操作按钮 -->
          <div class="filter-actions">
            <a-button @click="cancelAddProductFilter">取消</a-button>
            <a-button type="primary" @click="applyAddProductFilter" style="margin-left: 8px;">确定</a-button>
          </div>
        </div>
      </a-modal>
      <div class="product-list">
        <a-table
          :rowKey="(record) => record.id"
          :columns="add_product_columns"
          :loading="add_product_loading"
          :data-source="add_product_list_data"
          :sortDirections="['descend', 'ascend', '']"
          :rowSelection="{
            selectedRowKeys: add_product_selectedRowKeys,
            onChange: onAddProductSelectChange,
          }"
          :pagination="add_product_pagination"
          @change="handleAddProductTableChange"
          :scroll="{ y: 'calc(100vh - 300px)' }"
        >
          <template slot="goodInfo" slot-scope="text">
            <div class="goodsInfoWapper">
              <img :src="text.img" alt="" class="goodImg" />
              <div class="goodRight">
                <span class="goodTitle">
                  <a-tag color="purple" v-if="text.category_name">
                    {{ text.category_name }}
                  </a-tag>
                  {{ text.name || '--' }}
                </span>
                <span class="goodId">
                  ID {{ text.id || '--' }}
                  <a-icon type="copy" @click="text_copy(text.id)" />
                </span>
                <b style="color: green" v-if="text.price"><a-tag color="blue" v-if="text.channel_id">渠道品</a-tag> 售价:{{ text.price }}元</b>
                <div v-if="text.gray_reason">
                  <span
                    style="color: red; font-size: 10px"
                    class="errtip"
                    v-for="item in text.gray_reason"
                    :key="item"
                    >{{ item }}</span
                  >
                </div>
              </div>
            </div>
          </template>
          <template slot="cos_ratio" slot-scope="text">
            <b v-if="text.cos_ratio" style="color: green; margin-right: 5px"
              >{{ text.cos_ratio }}%</b
            >
            <b v-else>--</b>
            <a-tag color="green" v-if="text.cos_ratio">赚:{{ text.cos_fee }}元</a-tag>
          </template>
          <template slot="action" slot-scope="text, record">
            <a-button
              type="danger"
              size="small"
              @click="handleAddProductBlack(record)"
              :loading="record.blacklisting"
            >
              加黑
            </a-button>
          </template>
        </a-table>
      </div>
      <div :style="{ position: 'absolute', right: 0, bottom: 0, width: '100%', borderTop: '1px solid #e9e9e9', padding: '10px 16px', background: '#fff', textAlign: 'left', zIndex: 1 }">
        <a-button
          type="primary"
          @click="confirmAddProduct"
          :disabled="add_product_selectedRowKeys.length == 0"
          :loading="add_product_confirm_loading"
          :style="{ marginRight: '8px' }"
        >
          确定选择 {{ add_product_selectedRowKeys.length }} 个
        </a-button>
        <a-button
          type="danger"
          @click="showAddProductBlackModal"
          :disabled="add_product_selectedRowKeys.length == 0"
          :style="{ marginRight: '8px' }"
        >
          批量加黑
        </a-button>
        <a-button
          :style="{ marginRight: '8px' }"
          @click="clearAddProductSelection"
          :disabled="add_product_selectedRowKeys.length == 0"
        >
          清空选择
        </a-button>
        <a-button @click="closeAddProductDrawer">取消</a-button>
      </div>
    </a-drawer>

    <!-- 单个加黑模态框 -->
    <a-modal
      title="加黑商品"
      :visible="add_product_singleBlackModalVisible"
      width="600px"
      @ok="handleSingleBlackConfirm"
      @cancel="handleSingleBlackCancel"
      okText="确认加黑"
      cancelText="取消"
      okType="danger"
    >
      <div style="padding: 20px 0;">
        <div style="margin-bottom: 16px; color: #666;" v-if="add_product_singleBlackRecord">
          确定要将商品 <strong style="color: #ff4d4f;">"{{ add_product_singleBlackRecord.name || add_product_singleBlackRecord.id }}"</strong> 加入黑名单吗？加入黑名单的商品将不会进行投放。
        </div>
        <a-form-item label="加黑原因" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-textarea
            v-model="add_product_singleBlackReason"
            placeholder="请输入加黑原因（选填）"
            :rows="4"
            :maxLength="200"
            show-count
          />
        </a-form-item>
      </div>
    </a-modal>

    <!-- 批量加黑模态框 -->
    <a-modal
      title="批量加黑"
      :visible="add_product_blackModalVisible"
      width="600px"
      @ok="handleAddProductBlackModalOk"
      @cancel="handleAddProductBlackModalCancel"
      :confirmLoading="add_product_blackLoading"
      okText="确认加黑"
      cancelText="取消"
      okType="danger"
    >
      <div style="padding: 20px 0;">
        <div style="margin-bottom: 16px; color: #666;">
          确定要将选中的 <strong style="color: #ff4d4f;">{{ add_product_selectedRowKeys.length }}</strong> 个商品加入黑名单吗？加入黑名单的商品将不会进行投放。
        </div>
        <a-form-item label="加黑原因" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-textarea
            v-model="add_product_blackReason"
            placeholder="请输入加黑原因（选填）"
            :rows="4"
            :maxLength="200"
            show-count
          />
        </a-form-item>
      </div>
    </a-modal>

    <!-- 确认所选商品弹窗 -->
    <a-modal
      title="确认所选商品"
      :visible="addProductConfirmModalVisible"
      width="1450px"
      @ok="handleAddProductConfirmOk"
      @cancel="closeAddProductConfirmModal"
      :confirmLoading="addProductApplyLoading"
    >
      <!-- 批量设置区域 -->
      <div
        class="batch-setting-area"
        style="
          margin-bottom: 20px;
          padding: 10px;
          background: #f5f5f5;
          border-radius: 4px;
        "
      >
        <a-row style="display: flex; align-items: center; flex-wrap: wrap; gap: 16px;">
          <a-form-item label="" style="margin-bottom: 0;">
            <span style="margin-right: 8px;">投放规则：</span>
            <a-checkbox
              :checked="addProductIsGetDouyin == 1 ? true : false"
              @change="onAddProductDouyinChange"
              >抖音视频</a-checkbox
            >
          </a-form-item>
          <a-form-item label="" style="margin-bottom: 0;">
            <a-checkbox
              :checked="addProductIsGetDouyinTw == 1 ? true : false"
              @change="onAddProductDouyinTwChange"
              >抖音图文</a-checkbox
            >
          </a-form-item>
          <a-form-item label="" style="margin-bottom: 0;" v-if="addProductIsGetDouyin == 1 || addProductIsGetDouyinTw == 1">
            <a-checkbox
              :checked="addProductDixiao == 1 ? true : false"
              @change="onAddProductDxChange"
              >过滤低效</a-checkbox
            >
          </a-form-item>
          <a-form-item label="" style="margin-bottom: 0;" v-if="addProductIsGetDouyin == 1 || addProductIsGetDouyinTw == 1">
            <a-checkbox
              :checked="addProductPaichu == 1 ? true : false"
              @change="onAddProductPcChange"
              >排除低效</a-checkbox
            >
          </a-form-item>
          <a-form-item label="" style="margin-bottom: 0;" v-if="addProductIsGetDouyin == 1 || addProductIsGetDouyinTw == 1">
            <a-checkbox
              :checked="addProductPaichuNo == 1 ? true : false"
              @change="onAddProductPcNoChange"
              >排除无素材</a-checkbox
            >
          </a-form-item>
          <a-form-item label="" style="margin-bottom: 0;">
            <a-checkbox
              :checked="addProductYongjing == 1 ? true : false"
              @change="onAddProductYjChange"
              >排除无佣品</a-checkbox
            >
          </a-form-item>
          <a-form-item label="" style="margin-bottom: 0;">
            <a-checkbox
              :checked="addProductDiyong == 1 ? true : false"
              @change="onAddProductDyChange"
              >排除低佣品</a-checkbox
            >
            <span v-if="addProductDiyong == 1" style="margin-left: 8px;">
              (
              <a-input-number
                v-model="addProductDiyongCommissionRate"
                :min="0"
                :max="100"
                style="width: 60px;"
                size="small"
              />
              %或以下)
            </span>
          </a-form-item>
          <a-form-item label="" style="margin-bottom: 0;">
            <a-checkbox
              :checked="addProductIswg == 1 ? true : false"
              @change="onAddProductWgChange"
              >排除违规品 </a-checkbox
            ><a-icon type="question-circle" @click="showAddProductWgTip" />
          </a-form-item>
          <a-form-item label="" style="margin-bottom: 0; margin-left: auto;">
            <a-button
              :loading="addProductApplyLoading"
              type="primary"
              @click="applyAddProductOriginFilter"
            >
              应用过滤
            </a-button>
          </a-form-item>
        </a-row>
      </div>

      <a-table
        :dataSource="addProductOriginList"
        :rowKey="(record) => record.id"
        :pagination="false"
        :scroll="{ y: 430 }"
      >
        <a-table-column title="商品信息" align="center" width="550">
          <template slot-scope="text, record, index">
            <div class="goodsInfoWapper">
              <img
                :src="record.img"
                alt=""
                class="goodImg"
                style="width: 50px; height: 50px"
              />
              <div class="goodRight">
                <span
                  class="goodTitle"
                  style="
                    display: block;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 165px;
                  "
                >
                  <a-badge
                    :count="index + 1"
                    :number-style="{ backgroundColor: '#52c41a' }"
                    :overflow-count="999"
                  />{{ record.name || '--' }}</span
                >
                <span class="goodId">ID {{ record.id || '--' }}</span>
              </div>
            </div>
          </template>
        </a-table-column>
        <a-table-column
          title="售价"
          align="center"
          width="60"
          :sorter="(a, b) => {
            const aValue = parseFloat(a.price) || 0;
            const bValue = parseFloat(b.price) || 0;
            return aValue - bValue;
          }"
          :sortDirections="['ascend', 'descend']"
          dataIndex="price"
        >
          <template slot-scope="text, record">
            <b v-if="record.price" style="color: green">{{ record.price }}元</b>
            <b v-else>--</b>
            <div>
              <a-tag color="purple" v-if="record.category_name">{{
                record.category_name
              }}</a-tag>
            </div>
          </template>
        </a-table-column>
        <a-table-column
          title="公开佣金"
          align="center"
          width="60"
          :sorter="(a, b) => {
            const aValue = parseFloat(a.cos_ratio) || 0;
            const bValue = parseFloat(b.cos_ratio) || 0;
            return aValue - bValue;
          }"
          :sortDirections="['ascend', 'descend']"
          dataIndex="cos_ratio"
        >
          <template slot-scope="text, record">
            <b
              v-if="record.cos_ratio"
              style="color: green; margin-right: 5px"
              >{{ record.cos_ratio }}%
            </b>
            <b v-else>--</b>
            <a-tag color="green" v-if="record.cos_ratio"
              >赚:{{ record.cos_fee }}元</a-tag
            >
          </template>
        </a-table-column>

        <a-table-column title="素材内容" align="center" width="200">
          <template slot-scope="text, record">
            智能优选素材
            <span v-if="addProductIsGetDouyin == 1 || addProductIsGetDouyinTw == 1">
              + 抖音/千川视频/抖音图文
              <b style="color: green" v-if="record.video_status && record.video_list && record.video_list.length > 0"
                >{{ record.video_list.length }}条</b
              >
              <b style="color: red" v-else-if="record.video_status && record.video_list && record.video_list.length == 0">{{ record.video_list.length }}条</b>
              <b style="color: red" v-else>待拉取</b>
            </span>
            <a-button
              type="link"
              size="small"
              v-if="record.video_status"
              @click="openAddProductVideo(record)"
            >
              添加抖音视频
            </a-button>
          </template>
        </a-table-column>

        <a-table-column title="操作" align="center" width="50">
          <template slot-scope="text, record">
            <a-icon type="delete" @click="delAddProductSelect(record)" />
          </template>
        </a-table-column>
      </a-table>

      <div style="text-align: right; margin-top: 10px">
        <a-button
          type="link"
          @click="showAddProductPcList"
          style="color: red;"
          >已排除商品列表 ({{ addProductPcList.length }})</a-button
        >
      </div>
    </a-modal>

    <!-- 添加商品视频组件 -->
    <addVideo
      v-if="addProductVideoVisible"
      :advertiser_id="advertiser_id"
      marketing_goal="VIDEO_PROM_GOODS"
      :aweme_id="addProductVideoDrawerKey ? (addProductVideoDrawerKey.aweme_id || order_detail.aweme_id || '') : (order_detail.aweme_id || '')"
      :product_list="addProductVideoDrawerProduct || {}"
      :newSelectList="addProductVideoDrawerSelectList"
      @receive="addProductVideoReceive"
      @closeAddDrawer="closeAddProductVideoDrawer"
    />

    <!-- 排除商品列表抽屉 -->
    <a-drawer
      title="已排除商品列表"
      placement="right"
      :visible="addProductPcListVisible"
      width="800px"
      @close="addProductPcListVisible = false"
    >
      <div v-if="addProductPcList.length > 0">
        <a-table
          :dataSource="addProductPcList"
          :rowKey="(record) => record.id"
          :pagination="false"
          :scroll="{ y: 'calc(100vh - 230px)' }"
        >
          <a-table-column title="商品信息" align="center" width="300">
            <template slot-scope="text, record">
              <div class="goodsInfoWapper">
                <img
                  :src="record.img"
                  alt=""
                  class="goodImg"
                  style="width: 50px; height: 50px"
                />
                <div class="goodRight">
                  <span
                    class="goodTitle"
                    style="
                      display: block;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      width: 200px;
                    "
                  >
                    {{ record.name || '--' }}</span
                  >
                  <span class="goodId">ID {{ record.id || '--' }}</span>
                </div>
              </div>
            </template>
          </a-table-column>
          <a-table-column title="售价" align="center" width="80">
            <template slot-scope="text, record">
              <b v-if="record.price" style="color: green"
                >{{ record.price }}元</b
              >
              <b v-else>--</b>
            </template>
          </a-table-column>
          <a-table-column title="公开佣金" align="center" width="100">
            <template slot-scope="text, record">
              <b
                v-if="record.cos_ratio"
                style="color: green; margin-right: 5px"
                >{{ record.cos_ratio }}%
              </b>
              <b v-else>--</b>
              <a-tag color="green" v-if="record.cos_ratio"
                >赚:{{ record.cos_fee }}元</a-tag
              >
            </template>
          </a-table-column>
          <a-table-column title="排除原因" align="center" width="200">
            <template slot-scope="text, record">
              <a-tag color="red">{{ record.excludeReason }}</a-tag>
            </template>
          </a-table-column>
          <a-table-column title="操作" align="center" width="200">
            <template slot-scope="text, record">
              <a-button
                type="primary"
                size="small"
                @click="restoreAddProductExcludedGood(record)"
                :loading="record.restoring"
                :disabled="record.restoring"
                style="margin-right: 8px"
              >
                恢复
              </a-button>
            </template>
          </a-table-column>
        </a-table>
        <div style="margin-top: 10px; text-align: center">
          <a-tag color="red">共排除 {{ addProductPcList.length }} 个商品</a-tag>
          <div style="margin-top: 10px">
            <a-button
              type="primary"
              @click="restoreAllAddProductExcludedGoods"
              :loading="addProductRestoringAll"
              :disabled="addProductPcList.length === 0 || addProductRestoringAll"
            >
              全部恢复
            </a-button>
          </div>
        </div>
      </div>
      <div v-else style="text-align: center; padding: 50px">
        <a-empty description="暂无排除商品" />
      </div>
    </a-drawer>

    <!-- 违规词提示弹窗 -->
    <a-modal
      title="自动排除商品名称中出现以下违规词的商品"
      :visible="addProductWgTipVisible"
      width="800px"
      @ok="addProductWgTipVisible = false"
      @cancel="addProductWgTipVisible = false"
    >
      <div style="max-height: 500px; overflow-y: auto">
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold"
            >美白, 减肥, 祛湿, 去屑, 防脱, 祛痘, 去口臭, 益生菌, 见效, 灭菌,
            杀虫, 除菌, 抗菌, 消炎，结冰，</span
          >
        </div>
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold">材质宣称禁用词</span><br />
          <span
            >食品级, 抗菌, 抑菌, 灭菌, 纯棉, 真丝, 足银, 冰感, 凉丝,
            艾草, 中草药, 云南白药, 激素, 抗生素, 处方, 药方</span
          >
        </div>
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold"
            >消费者权益过度承诺（产品详情里确实包含的承诺除外）</span
          ><br />
          <span
            >质保, 包退, 包换, 试用, 换新, 无效退款, 家庭必备,
            保险公司承保, 终身, 永久, 绝对, 万能, 特效, 高效, 速效, 全效,
            强效</span
          >
        </div>
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold">所有暗示性词汇</span><br />
          <span
            >风水, 转运, 辟邪, 镇宅, 旺财, 旺夫, 招财, 本命, 护身, 算卦, 佛牌,
            开光, 化煞，抓周，塔罗牌，增财，保平安</span
          >
        </div>
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold">品牌及变体（假冒品牌）</span><br />
          <span
            >小米, 小米有品, 九牧王, 茅台, 国宴, 特供, 专供, 驰名商标,
            老字号，李宁</span
          >
        </div>
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold">拆分/谐音规避检测</span><br />
          <span
            >米白（美白, 会敏（抗敏）, 黑黑头头（祛黑头）, 粉粉刺刺（祛粉刺）,
            冰冰感感（冰感温</span
          ><br />
          <span>暖暖宫宫（暖宫），</span>
        </div>
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold">虚假/夸大宣传类</span><br />
          <span>最：最好、最优、最佳、最便宜、最划算、最受欢迎、最顶级</span
          ><br />
          <span
            >第一：销量第一、行业第一、全网顶级/极品/终极：顶级品质、极品享受、终极解决方案</span
          ><br />
          <span>国家级/世界级：国家级认证、世界级品质</span><br />
          <span>100%：100%有效、100%纯天然、100%正品、</span>
        </div>
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold">虚假承诺/无法验证</span><br />
          <span>包治百病/万能：什么病都能治、万能神器</span><br />
          <span>永不：永不褪色、永不松动、永不断裂</span><br />
          <span
            >绝无：绝无副作用、特效/神效：特效减肥，史上：史上最低价、史上最强</span
          >
        </div>
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold"
            >医疗/保健/美容效果暗示类 (极其敏感！)</span
          ><br />
          <span
            >治疗疾病/预防疾病：治疗、根治、预防/抗癌/防癌、消炎/抗炎/消肿/镇痛/止痛、提高免疫力</span
          ><br />
          <span>医疗技术/药用效果：医用、药用、处方、促进伤口愈合等</span><br />
          <span
            >美容功效的绝对化/医疗化：美白、祛斑、生发/育发/防脱、丰胸/壮阳/改善性功能、去皱纹/除皱、换肤、七天美白/三天见效(夸大宣称起效时间)。</span
          >
        </div>
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold">诱导消费/价格欺诈类</span><br />
          <span
            >限时/限量诱导、错过就没/错过等一年、史上最低价/全网最低价、再不买就涨价了、不恰当价格对比、原价XX元、虚构原价进行打折</span
          ><br />
          <span>逼迫下单、不买就亏了/不买后悔、赶紧抢/手慢无</span>
        </div>
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold">贬低他人/贬低竞争对手</span><br />
          <span>秒杀XX品牌/比XX品牌好十倍、直接贬低其他品牌或主播。</span>
        </div>
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold">无法证实的"权威"背书</span><br />
          <span
            >央视推荐/人民日报推荐、专家推荐/医生推荐、老字号、特供/专供</span
          >
        </div>
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold">虚拟商品</span><br />
          <span>虚拟软件、虚拟服务，无实物</span>
        </div>
        <div style="margin-bottom: 15px">
          <span style="color: #ff4d4f; font-weight: bold">⚠️</span>
          <span style="font-weight: bold">其他敏感词</span><br />
          <span
            >点击领红包/点击赚钱、随时提现/马上到账、驰名商标、祖传秘方/宫廷御用、万能/全能、投资/理财</span
          >
        </div>
      </div>
    </a-modal>

    <!-- 裂变策略配置弹窗 -->
    <a-modal
      :visible="fissionStrategyModalVisible"
      :title="isBatchFissionMode ? `批量裂变配置（已选择 ${batchFissionMaterials.length} 个素材）` : '素材裂变配置'"
      width="920px"
      class="fissionStrategyModal"
      centered
      @ok="confirmFissionStrategy"
      @cancel="cancelFissionStrategy"
      :confirmLoading="fissionStrategyLoading"
    >
      <div class="confBlock">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
          <span class="cofBlockName">
            裂变限制（ 单条素材每天可裂变1次，最多裂变5次 ）
            <span v-if="isBatchFissionMode" style="color: #1890ff; margin-left: 8px;">
              将使用相同策略对 {{ batchFissionMaterials.length }} 个素材进行裂变
            </span>
          </span>
          <a-button type="link" size="small" @click="applyRecommendedFissionStrategy">
            应用推荐策略
          </a-button>
        </div>
        <div class="confLine fxStart">
          <div class="confLineC" style="margin-top: 10px;">
            <div class="fission-strategy-grid">
              <!-- 第一行 -->
              <div class="strategy-item">
                <div class="strategy-header">
                  <h4 class="strategy-title">分镜替换</h4>
                  <a-switch
                    :checked="fissionStrategy.clip_replace === 1"
                    @change="handleFissionStrategyChange('clip_replace', $event)"
                    size="small"
                    checked-children="开"
                    un-checked-children="关"
                  />
                </div>
                <p class="strategy-desc">保留脚本,替换相似镜头</p>
              </div>

              <div class="strategy-item">
                <div class="strategy-header">
                  <h4 class="strategy-title">人物替换</h4>
                  <a-switch
                    :checked="fissionStrategy.robot_replace === 1"
                    @change="handleFissionStrategyChange('robot_replace', $event)"
                    size="small"
                    checked-children="开"
                    un-checked-children="关"
                  />
                </div>
                <p class="strategy-desc">将视频中的真人片段,替换为数字人</p>
              </div>

              <div class="strategy-item">
                <div class="strategy-header">
                  <h4 class="strategy-title">前贴扩写</h4>
                  <a-switch
                    :checked="fissionStrategy.pre_video_clip_replace === 1"
                    @change="handleFissionStrategyChange('pre_video_clip_replace', $event)"
                    size="small"
                    checked-children="开"
                    un-checked-children="关"
                  />
                </div>
                <p class="strategy-desc">在视频前段生成高衔接度新脚本,组成吸睛前贴</p>
              </div>

              <div class="strategy-item">
                <div class="strategy-header">
                  <h4 class="strategy-title">重新混剪</h4>
                  <a-switch
                    :checked="fissionStrategy.mix_cut === 1"
                    @change="handleFissionStrategyChange('mix_cut', $event)"
                    size="small"
                    checked-children="开"
                    un-checked-children="关"
                  />
                </div>
                <p class="strategy-desc">保留脚本,重新混剪画面</p>
              </div>

              <!-- 第二行 -->
              <div class="strategy-item">
                <div class="strategy-header">
                  <h4 class="strategy-title">爆款开头</h4>
                  <a-switch
                    :checked="fissionStrategy.hot_pre_video === 1"
                    @change="handleFissionStrategyChange('hot_pre_video', $event)"
                    size="small"
                    checked-children="开"
                    un-checked-children="关"
                  />
                </div>
                <p class="strategy-desc">筛选优质的爆款开头画面+脚本,替换原开头</p>
              </div>

              <div class="strategy-item">
                <div class="strategy-header">
                  <h4 class="strategy-title">行业爆款套路</h4>
                  <a-switch
                    :checked="fissionStrategy.derive_from_industry_hot_pattern === 1"
                    @change="handleFissionStrategyChange('derive_from_industry_hot_pattern', $event)"
                    size="small"
                    checked-children="开"
                    un-checked-children="关"
                  />
                </div>
                <p class="strategy-desc">沿用当前账户下选定的爆款素材结构,按顺序组装分镜画面</p>
              </div>

              <div class="strategy-item">
                <div class="strategy-header">
                  <h4 class="strategy-title">自有爆款套路</h4>
                  <a-switch
                    :checked="fissionStrategy.derive_from_chosen_hot_mid === 1"
                    @change="handleFissionStrategyChange('derive_from_chosen_hot_mid', $event)"
                    size="small"
                    checked-children="开"
                    un-checked-children="关"
                  />
                </div>
                <p class="strategy-desc">参考当前素材所在行业类目下的其他爆款素材结构,进行脚本仿写+按顺序组装分镜画面</p>
              </div>

              <div class="strategy-item">
                <div class="strategy-header">
                  <h4 class="strategy-title">原料分镜替换</h4>
                  <a-switch
                    :checked="fissionStrategy.raw_material_replace === 1"
                    @change="handleFissionStrategyChange('raw_material_replace', $event)"
                    size="small"
                    checked-children="开"
                    un-checked-children="关"
                  />
                </div>
                <p class="strategy-desc">替换原始素材中的分镜内容</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { qcApi, requestHttp, strLength } from '@utils/index';
import { LineChart } from '@components';
import moment from 'moment';
import { Modal } from 'ant-design-vue';
import addVideo from '../../../../createPlanNew/components/addVideo.vue';

// 违规词列表
const forbiddenWords = [
  '美白', '减肥', '祛湿', '去屑', '防脱', '祛痘', '去口臭', '益生菌', '见效', '灭菌',
  '杀虫', '除菌', '抗菌', '消炎', '结冰', '食品级', '抑菌', '纯棉', '真丝', '足银',
  '冰感', '凉丝', '艾草', '中草药', '云南白药', '激素', '抗生素', '处方', '药方',
  '质保', '包退', '包换', '试用', '换新', '无效退款', '家庭必备', '保险公司承保',
  '终身', '永久', '绝对', '万能', '特效', '高效', '速效', '全效', '强效',
  '风水', '转运', '辟邪', '镇宅', '旺财', '旺夫', '招财', '本命', '护身', '算卦',
  '佛牌', '开光', '化煞', '抓周', '塔罗牌', '增财', '保平安',
  '小米', '小米有品', '九牧王', '茅台', '国宴', '特供', '专供', '驰名商标', '老字号', '李宁',
  '米白', '会敏', '黑黑头头', '粉粉刺刺', '冰冰感感', '暖暖宫宫',
  '最好', '最优', '最佳', '最便宜', '最划算', '最受欢迎', '最顶级', '销量第一', '行业第一',
  '全网顶级', '极品', '终极', '国家级认证', '世界级品质', '100%有效', '100%纯天然', '100%正品',
  '包治百病', '永不褪色', '永不松动', '永不断裂', '绝无副作用', '特效减肥', '史上最低价', '史上最强',
  '治疗', '根治', '预防', '抗癌', '防癌', '抗炎', '消肿', '镇痛', '止痛', '提高免疫力',
  '医用', '药用', '促进伤口愈合', '祛斑', '生发', '育发', '丰胸', '壮阳', '改善性功能',
  '去皱纹', '除皱', '换肤', '七天美白', '三天见效',
  '限时', '限量', '错过就没', '错过等一年', '全网最低价', '再不买就涨价了', '原价XX元',
  '不买就亏了', '不买后悔', '赶紧抢', '手慢无',
  '秒杀XX品牌', '比XX品牌好十倍',
  '央视推荐', '人民日报推荐', '专家推荐', '医生推荐',
  '虚拟软件', '虚拟服务',
  '点击领红包', '点击赚钱', '随时提现', '马上到账', '祖传秘方', '宫廷御用', '全能', '投资', '理财',
];

const log_columns = [
  {
    title: '操作时间',
    dataIndex: 'create_time',
    key: 'create_time',
    width: 90,
  },
  {
    title: '操作类型',
    dataIndex: 'content_title',
    key: 'content_title',
    width: 90,
  },
  {
    title: '操作内容',
    key: 'content',
    scopedSlots: { customRender: 'content' },
    width: 200,
  },
  {
    title: '操作人',
    dataIndex: 'operator',
    key: 'operator',
    width: 90,
  },
  {
    title: '操作IP',
    dataIndex: 'opt_ip',
    key: 'opt_ip',
    width: 90,
  },
];
const video_columns = [
  {
    title: '创意',
    dataIndex: 'create_time',
    key: 'create_time',
    width: 90,
  },
  {
    title: '审核状态',
    dataIndex: 'content_title',
    key: 'content_title',
    width: 90,
  },
  {
    title: '消耗',
    key: 'content',
    scopedSlots: { customRender: 'content' },
    width: 200,
  },
  {
    title: '展示次数',
    dataIndex: 'operator',
    key: 'operator',
    width: 90,
  },
  {
    title: '点击率',
    dataIndex: 'opt_ip',
    key: 'opt_ip',
    width: 90,
  },
];
const material_columns = [
  {
    title: '创意',
    key: 'info',
    scopedSlots: { customRender: 'info' },
    width: 280,
    fixed: 'left',
  },
  {
    title: '素材状态',
    scopedSlots: { customRender: 'material' },
    key: 'material',
    width: 90,
    fixed: 'left',
  },
  {
    title: '审核状态',
    scopedSlots: { customRender: 'status' },
    key: 'status',
    fixed: 'left',
    width: 90,
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
    key: 'action',
    fixed: 'left',
    align: 'center',
    width: 100,
  },
  {
    title: '消耗',
    dataIndex: 'stat_cost_for_roi2',
    key: 'stat_cost_for_roi2',
    align: 'center',
    sorter: true,
    width: 100,
  },
  {
    title: '支付ROI',
    dataIndex: 'total_prepay_and_pay_order_roi2',
    key: 'total_prepay_and_pay_order_roi2',
    align: 'center',
    sorter: true,
    width: 100,
  },
  {
    title: '成交金额',
    dataIndex: 'total_pay_order_gmv_for_roi2',
    key: 'total_pay_order_gmv_for_roi2',
    align: 'center',
    sorter: true,
    width: 100,
  },
  {
    title: '成交订单数',
    dataIndex: 'total_pay_order_count_for_roi2',
    key: 'total_pay_order_count_for_roi2',
    align: 'center',
    sorter: true,
    width: 120,
  },
  {
    title: '成交订单成本',
    dataIndex: 'total_cost_per_pay_order_for_roi2',
    key: 'total_cost_per_pay_order_for_roi2',
    sorter: true,
    width: 120,
  },
  {
    title: '成交智能优惠券金额',
    dataIndex: 'total_pay_order_coupon_amount_for_roi2',
    key: 'total_pay_order_coupon_amount_for_roi2',
    sorter: true,
    width: 190,
  },
  {
    title: '未完结预售订单预估金额',
    dataIndex: 'total_unfinished_estimate_order_gmv_for_roi2',
    key: 'total_unfinished_estimate_order_gmv_for_roi2',
    sorter: true,
    width: 190,
  },
];
const user_log_columns = [
  { title: '操作时间', dataIndex: 'createtime', key: 'createtime', width: 90 },
  { title: '操作内容', key: 'content', dataIndex: 'content', width: 200 },
  { title: '操作人', dataIndex: 'nickname', key: 'nickname', width: 90 },
];
const monitor_log_columns = [
  {
    title: '户ID',
    dataIndex: 'advertiser_id',
    key: 'advertiser_id',
    width: 180,
  },
  { title: '计划ID', dataIndex: 'order_id', key: 'order_id', width: 180 },
  { title: '监控类型', dataIndex: 'type_text', key: 'type_text', width: 130 },
  { title: '监控反馈', dataIndex: 'content', key: 'content' },
  { title: '创建时间', dataIndex: 'createtime', key: 'createtime', width: 150 },
];
const add_product_columns = [
  {
    title: '商品信息',
    key: 'goodInfo',
    width: 250,
    scopedSlots: { customRender: 'goodInfo' },
  },
  {
    title: '公开佣金',
    key: 'cos_ratio',
    align: 'center',
    width: 140,
    scopedSlots: { customRender: 'cos_ratio' },
  },
  {
    title: '销量',
    dataIndex: 'sell_num',
    key: 'sell_num',
    sorter: true,
    align: 'center',
    width: 80,
  },
  {
    title: '上架时间',
    dataIndex: 'audit_time',
    key: 'audit_time',
    align: 'center',
    sorter: true,
    width: 100,
  },
  {
    title: '库存',
    dataIndex: 'stock_num',
    key: 'stock_num',
    align: 'center',
    sorter: true,
    width: 100,
  },
  {
    title: '操作',
    key: 'action',
    align: 'center',
    width: 100,
    fixed: 'right',
    scopedSlots: { customRender: 'action' },
  },
];
const adcolumns = [
  {
    title: '时间',
    dataIndex: 'stat_datetime',
    width: 200,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'stat_datetime' },
    fixed: 'left',
  },
  {
    title: '消耗（元）',
    dataIndex: 'stat_cost',
    key: 'stat_cost',
    align: 'center',
    width: 130,
  },
  {
    title: '成交金额',
    dataIndex: 'pay_order_amount',
    key: 'pay_order_amount',
    align: 'center',
    width: 130,
  },
  {
    title: '支付ROI',
    dataIndex: 'prepay_and_pay_order_roi',
    key: 'prepay_and_pay_order_roi',
    align: 'center',
    width: 130,
  },
  {
    title: '成交订单数',
    dataIndex: 'pay_order_count',
    key: 'pay_order_count',
    align: 'center',
    width: 130,
  },
  {
    title: '整体成交订单成本',
    dataIndex: 'total_cost_per_pay_order_for_roi2',
    key: 'total_cost_per_pay_order_for_roi2',
    align: 'center',
    width: 130,
  },
];
export default {
  name: 'detail',
  props: {
    advertiser_id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      editname:'',
      // 预算编辑相关
      editBudget: null,
      budgetLoading: false,
      // ROI 目标编辑相关
      editRoiGoal: null,
      roiLoading: false,
      roiLastModify: {
        loading: false,
        error: '',
        data: null,
      },
      spinning_detail: false,
      order_detail: {},
      orderDrawer: false,
      detailTab: '1',
      ad: {},
      log_data: [],
      ad_log_pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} 共 ${total} 条`,
        hideOnSinglePage: false,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      ad_id: '',
      log_columns,
      video_columns,
      video_data: [],
      campaign_scene: '',
      marketing_scene: '',
      material_type: 'VIDEO',
      material_data: [],
      material_columns,
      statusData: [
        { name: '全部计划状态', value: '' },
        { name: '新建审核中', value: 'AUDIT' },
        { name: '已删除', value: 'DELETE' },
        { name: '投放中', value: 'DELIVERY_OK' },
        { name: '已暂停', value: 'DISABLE' },
        { name: '草稿', value: 'DRAFT' },
        { name: '数据错误', value: 'ERROR' },
        { name: '落地页暂不可用', value: 'EXTERNAL_URL_DISABLE' },
        { name: '已终止', value: 'FROZEN' },
        { name: '关联直播间未开播', value: 'LIVE_ROOM_OFF' },
        { name: '不在投放时段', value: 'NO_SCHEDULE' },
        { name: '审核不通过', value: 'OFFLINE_AUDIT' },
        { name: '账户余额不足', value: 'OFFLINE_BALANCE' },
        { name: '广告超出预算', value: 'OFFLINE_BUDGET' },
        { name: '预上线', value: 'PRE_ONLINE' },
        { name: 'QUOTA配额不足暂停计划', value: 'QUOTA_DISABLE' },
        { name: '修改审核中', value: 'REAUDIT' },
        { name: '全域推广暂停', value: 'ROI2_DISABLE' },
        { name: '系统暂停', value: 'SYSTEM_DISABLE' },
        { name: '已完成', value: 'TIME_DONE' },
        { name: '未到达投放时间', value: 'TIME_NO_REACH' },
        { name: '账户超出预算', value: 'ADVERTISER_OFFLINE_BUDGET' },
        { name: '账户接近预算', value: 'ADVERTISER_PRE_OFFLINE_BUDGET' },
        { name: '异常，请联系审核人员', value: 'AUDIT_STATUS_ERROR' },
        { name: '关联抖音号不可投', value: 'AWEME_ACCOUNT_DISABLED' },
        { name: '已被广告组暂停', value: 'CAMPAIGN_DISABLE' },
        { name: '广告组超出预算', value: 'CAMPAIGN_OFFLINE_BUDGET' },
        { name: '广告组接近预算', value: 'CAMPAIGN_PRE_OFFLINE_BUDGET' },
      ],

      user_log_columns,
      user_log_data: [],
      monitor_log_columns,
      monitor_log_data: [],

      material_status: 'DELIVERY_OK',
      search_keyword: '',

      range_date: [
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],

      ad_range_date: [
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],

      sortby: 'material_id',
      sort: 'descend',
      page: 1,
      pagesize: 10,
      pagination: {
        current: 1,
        pageSize: 100,
        total: 0,
        pageSizeOptions: ['100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        hideOnSinglePage: false,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      videoVisible: false,
      product_list: {
        id: '',
      },
      newSelectList: [],
      materialList: [],
      resultvisible: false,
      titleModalVisible: false,
      titleInput: '',
      titleList: [],
      select_list: [],
      addloading: false,
      selectedRowKeys: [],
      selectedRows: [],
      analysis_type: '',
      adlist: [],
      spinning: false,
      
      // 商品相关数据字段
      product_data: [],
      product_columns: [
        {
          title: '商品信息',
          key: 'product_info',
          scopedSlots: { customRender: 'product_info' },
          width: 300,
          fixed: 'left',
        },
        {
          title: '商品状态',
          scopedSlots: { customRender: 'product_status' },
          key: 'product_status',
          width: 90,
          fixed: 'left',
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'product_action' },
          key: 'product_action',
          fixed: 'left',
          align: 'center',
          width: 60,
        },
        {
          title: '消耗',
          dataIndex: 'stats_info.stat_cost_for_roi2',
          key: 'stat_cost_for_roi2',
          align: 'center',
          sorter: true,
          width: 100,
        },
        {
          title: '支付ROI',
          dataIndex: 'stats_info.total_prepay_and_pay_order_roi2',
          key: 'total_prepay_and_pay_order_roi2',
          align: 'center',
          sorter: true,
          width: 100,
        },
        {
          title: '成交金额',
          dataIndex: 'stats_info.total_pay_order_gmv_for_roi2',
          key: 'total_pay_order_gmv_for_roi2',
          align: 'center',
          sorter: true,
          width: 100,
        },
        {
          title: '成交订单数',
          dataIndex: 'stats_info.total_pay_order_count_for_roi2',
          key: 'total_pay_order_count_for_roi2',
          align: 'center',
          sorter: true,
          width: 120,
        },
        {
          title: '成交订单成本',
          dataIndex: 'stats_info.total_cost_per_pay_order_for_roi2',
          key: 'total_cost_per_pay_order_for_roi2',
          sorter: true,
          width: 120,
        },
        {
          title: '成交智能优惠券金额',
          dataIndex: 'stats_info.total_pay_order_coupon_amount_for_roi2',
          key: 'total_pay_order_coupon_amount_for_roi2',
          sorter: true,
          width: 190,
        },
        {
          title: '未完结预售订单预估金额',
          dataIndex: 'stats_info.total_unfinished_estimate_order_gmv_for_roi2',
          key: 'total_unfinished_estimate_order_gmv_for_roi2',
          sorter: true,
          width: 190,
        },
      ],
      product_status: 'ALL',
      product_search_keyword: '',
      product_sortby: 'product_id',
      product_sort: 'descend',
      product_page: 1,
      product_pagesize: 10,
      product_pagination: {
        current: 1,
        pageSize: 100,
        total: 0,
        pageSizeOptions: ['100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        hideOnSinglePage: false,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      selectedProductRowKeys: [],
      selectedProductRows: [],

      // 补商品相关数据字段
      addProductDrawerVisible: false,
      add_product_list_data: [],
      add_product_selectedRowKeys: [],
      add_product_selectedRows: [],
      add_product_search_ids: '',
      add_product_search_name: '',
      add_product_loading: false,
      // 筛选相关数据
      add_product_filterModalVisible: false,
      add_product_filterTimeout: null, // 防抖定时器
      add_product_priceRange: {
        min: null,
        max: null
      },
      add_product_commissionRange: {
        min: null,
        max: null
      },
      add_product_selectedPriceRange: '不限',
      add_product_selectedCommissionRange: '不限',
      add_product_priceRanges: [
        { label: '不限', value: '不限' },
        { label: '¥0-¥10', value: '0-10' },
        { label: '¥10-¥30', value: '10-30' },
        { label: '¥30-¥50', value: '30-50' },
        { label: '¥50-¥100', value: '50-100' },
        { label: '¥100-¥500', value: '100-500' },
        { label: '≥ ¥500', value: '500+' }
      ],
      add_product_commissionRanges: [
        { label: '不限', value: '不限' },
        { label: '0%-10%', value: '0-10' },
        { label: '10%-20%', value: '10-20' },
        { label: '20%-30%', value: '20-30' },
        { label: '30%-40%', value: '30-40' },
        { label: '40%-50%', value: '40-50' },
        { label: '≥50%', value: '50+' }
      ],
      add_product_priceSectionExpanded: true,
      add_product_commissionSectionExpanded: true,
      add_product_origin_list_data: [], // 原始数据，用于筛选
      add_product_confirm_loading: false,
      // 加黑相关数据
      add_product_blackModalVisible: false,
      add_product_blackReason: '',
      add_product_blackLoading: false,
      add_product_singleBlackModalVisible: false,
      add_product_singleBlackRecord: null,
      add_product_singleBlackReason: '',
      add_product_page: 1,
      add_product_pagesize: 100,
      add_product_pagination: {
        current: 1,
        pageSize: 100,
        total: 0,
        pageSizeOptions: ['100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        hideOnSinglePage: false,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      add_product_sortby: 'audit_time',
      add_product_sort: 'descend',
      add_product_columns,

      // 确认商品弹窗相关数据
      addProductConfirmModalVisible: false,
      addProductOriginList: [],
      addProductPcList: [],
      addProductPcListVisible: false,
      addProductApplyLoading: false,
      addProductFilterApplied: false, // 是否已点击应用过滤
      addProductYongjing: 0,
      addProductDiyong: 0,
      addProductIswg: 0,
      addProductDiyongCommissionRate: 1,
      addProductWgTipVisible: false,
      addProductRestoringAll: false,
      // 抖音视频相关
      addProductIsGetDouyin: 0,
      addProductIsGetDouyinTw: 0,
      addProductDixiao: 0,
      addProductPaichu: 0,
      addProductPaichuNo: 0,
      // 添加商品视频相关
      addProductVideoVisible: false,
      addProductVideoDrawerProduct: null,
      addProductVideoDrawerKey: null,
      addProductVideoDrawerSelectList: [],

      // 裂变策略配置相关
      fissionStrategyModalVisible: false,
      fissionStrategyLoading: false,
      currentFissionMaterial: null, // 当前要裂变的素材
      isBatchFissionMode: false, // 是否为批量裂变模式
      batchFissionMaterials: [], // 批量裂变的素材列表
      fissionStrategy: {
        clip_replace: 1,
        robot_replace: 0,
        hot_pre_video: 1,
        mix_cut: 1,
        pre_video_clip_replace: 1,
        raw_material_replace: 1,
        derive_from_chosen_hot_mid: 1,
        derive_from_industry_hot_pattern: 0,
      },

      // 数据趋势相关变量
      adlineChartData: {
        expectedData: [],
        actualData: [],
        yAxis1: '消耗',
        yAxis2: '成交金额',
        xAxisdata: [],
      },
      adTrendDate: moment().format('YYYY-MM-DD'),
      adloading: false,
      adtableData: [],
      adcolumns,
      adyAxis1options: [
        {
          value: '0',
          name: 'stat_cost',
          label: '消耗',
          disabled: false,
        },
        {
          value: '1',
          name: 'pay_order_amount',
          label: '成交金额',
          disabled: true,
        },
        {
          value: '2',
          name: 'prepay_and_pay_order_roi',
          label: '支付ROI',
          disabled: false,
        },
        {
          value: '3',
          name: 'pay_order_count',
          label: '成交订单数',
          disabled: false,
        },
        {
          value: '4',
          name: 'total_cost_per_pay_order_for_roi2',
          label: '整体成交订单成本',
          disabled: false,
        },
      ],
      adyAxis2options: [
        {
          value: '0',
          name: 'stat_cost',
          label: '消耗',
          disabled: true,
        },
        {
          value: '1',
          name: 'pay_order_amount',
          label: '成交金额',
          disabled: false,
        },
        {
          value: '2',
          name: 'prepay_and_pay_order_roi',
          label: '支付ROI',
          disabled: false,
        },
        {
          value: '3',
          name: 'pay_order_count',
          label: '成交订单数',
          disabled: false,
        },
        {
          value: '4',
          name: 'total_cost_per_pay_order_for_roi2',
          label: '整体成交订单成本',
          disabled: false,
        },
      ],
      adyAxis1name: 'stat_cost',
      adyAxis2name: 'pay_order_amount',
    };
  },

  components: {
    addVideo,
    LineChart,
  },

  watch: {},

  computed: {
    // 检查是否可以批量裂变（选中的项必须都有消耗大于10）
    canBatchFission() {
      if (this.selectedRowKeys.length === 0) {
        return false;
      }
      // 检查所有选中的项是否都有消耗大于10
      const selectedMaterials = this.selectedRowKeys.map(index => {
        return this.material_data[index];
      });
      return selectedMaterials.every(item => 
        item != null && item.stat_cost_for_roi2 != null && item.stat_cost_for_roi2 > 5
      );
    },
    formatDetailRoiLastModifyHours() {
      const v = this.roiLastModify.data;
      if (v == null || v === '') {
        return '-';
      }
      const n = Number(v);
      return Number.isFinite(n) ? n : v;
    },
    detailRoiLastModifyValueClass() {
      const n = Number(this.roiLastModify.data);
      if (!Number.isFinite(n)) {
        return '';
      }
      if (n > 1) {
        return 'roi-popover-last-modify--ok';
      }
      if (n < 1) {
        return 'roi-popover-last-modify--warn';
      }
      return '';
    },
  },

  mounted() {},
  methods: {
    moment,
    closeOrderDrawer() {
      this.orderDrawer = false;
      this.$emit('closeOrderDrawer');
    },
    async setAdName(e) {
      console.log('备注', e);
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QY_EDIT_AD_NAME}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          ad_id: this.order_detail.ad_id,
          editname: this.editname,
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      this.order_detail.name = this.editname;
      // 设置成功后关闭 popover
      this.$refs.namePopover.visible = false;
    },
    // 修改预算
    async updateBudget(old_value) {
      if (!this.editBudget || this.editBudget <= 0) {
        this.$message.error('请输入有效的预算金额');
        return;
      }
      
      this.budgetLoading = true;
      
      try {
        const { code, msg } = await requestHttp({
          api: `${qcApi.EDIT_QY_AD_NEW}`,
          method: 'POST',
          params: {
            advertiser_id: this.advertiser_id,
            ad_id: this.order_detail.ad_id,
            edit_value: this.editBudget,
            edittype:'2',
            old_value: old_value,
          },
        });
        
        if (code == 0) {
          this.$message.error(msg);
          return;
        }
        
        this.$message.success('预算修改成功');
        this.$refs.budgetPopover.visible = false;
        
        // 刷新数据
        this.getData();
      } catch (error) {
        this.$message.error('修改预算失败');
        console.error(error);
      } finally {
        this.budgetLoading = false;
      }
    },
    
    onDetailRoiEditIconClick() {
      this.editRoiGoal = this.adlist?.[0]?.ad_info?.roi2_goal;
      this.fetchDetailRoiLastModifyHours();
    },
    onDetailRoiPopoverVisibleChange(visible) {
      if (!visible) {
        this.resetDetailRoiLastModify();
      }
    },
    resetDetailRoiLastModify() {
      this.roiLastModify = {
        loading: false,
        error: '',
        data: null,
      };
    },
    async fetchDetailRoiLastModifyHours() {
      const advertiser_id = this.advertiser_id;
      const ad_id =
        this.order_detail?.ad_id || this.adlist?.[0]?.ad_info?.id;
      this.roiLastModify = {
        loading: true,
        error: '',
        data: null,
      };
      try {
        if (!advertiser_id || ad_id == null || ad_id === '') {
          this.roiLastModify = {
            loading: false,
            error: '缺少账户或计划信息',
            data: null,
          };
          return;
        }
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.GET_AD_ROI_EDIT_TIME}`,
          method: 'POST',
          params: {
            advertiser_id,
            ad_id,
          },
        });
        if (code == 1 && data != null && data !== '') {
          this.roiLastModify = {
            loading: false,
            error: '',
            data,
          };
        } else {
          this.roiLastModify = {
            loading: false,
            error:
              msg != null && String(msg).trim() !== ''
                ? String(msg)
                : '获取修改时间失败',
            data: null,
          };
        }
      } catch (e) {
        const errMsg =
          (e && (e.message || e.msg)) || '网络异常，请稍后重试';
        this.roiLastModify = {
          loading: false,
          error: String(errMsg),
          data: null,
        };
      }
    },

    // 修改 ROI 目标
    async updateRoiGoal(old_value) {
      if (!this.editRoiGoal || this.editRoiGoal <= 0) {
        this.$message.error('请输入有效的 ROI 目标');
        return;
      }
      
      this.roiLoading = true;
      
      try {
        const { code, msg } = await requestHttp({
          api: `${qcApi.EDIT_QY_AD_NEW}`,
          method: 'POST',
          params: {
            advertiser_id: this.advertiser_id,
            ad_id: this.order_detail.ad_id,
            edit_value: this.editRoiGoal,
            edittype:'3',
            old_value: old_value,
          },
        });
        
        if (code == 0) {
          this.$message.error(msg);
          return;
        }
        
        this.$message.success('ROI 目标修改成功');
        this.$refs.roiPopover.visible = false;
        
        // 刷新数据
        this.getData();
      } catch (error) {
        this.$message.error('修改 ROI 目标失败');
        console.error(error);
      } finally {
        this.roiLoading = false;
      }
    },
    gotask() {
      this.$router.replace('/qy_task');
    },
    handleAnalysisChange(e) {
      console.log(e);
      this.analysis_type = e;
      this.page = 1;
      this.material_data = [];
      this.getAdMaterial();
    },
    addMaterial() {
      this.newSelectList = [];
      if (this.order_detail.multi_product_creative_list.length > 1) {
        this.$message.error('当前仅支持一个商品的计划补充素材');
        return;
      }
      this.product_list.id = this.ad?.product_info[0]?.product_id;
      this.materialList = [];
      if (this.material_data.length > 0) {
        for (let i = 0; i < this.material_data.length; i++) {
          const item = this.material_data[i];
          const coverUrl =
            item?.material_info?.video_material?.cover_image?.image_url ||
            item?.material_info?.image_material?.image_url ||
            '';
          this.materialList.push({
            advertiser_id: this.advertiser_id,
            filename: item?.material_info?.video_material?.title,
            duration: item?.material_info?.video_material?.video_duration,
            id: item?.material_info?.video_material?.video_id,
            imageUrl: coverUrl,
            image_mode: 'VIDEO_VERTICAL',
            type: 'VIDEO',
            video_title: item?.material_info?.video_material?.title,
            source: 'QIANCHUAN',
            material_id: item?.material_id,
            video_cover_url: coverUrl,
            url: item?.material_info?.video_material?.url,
          });
        }
      }
      this.videoVisible = true;
    },
    videoreceive(value) {
      // 选中的视频
      console.log('选中的视频千川', value);
      //过滤
      let select_list = [];
      if (value.video_material_list.length > 0) {
        for (let i = 0; i < value.video_material_list.length; i++) {
          const item = value.video_material_list[i];
          console.log('item.source', item.source);
          if (item.source == 'DOUYIN') {
            let dd = [];
            if (
              this.order_detail.multi_product_creative_list[0].video_material
            ) {
              dd =
                this.order_detail.multi_product_creative_list[0].video_material.filter(
                  function (it) {
                    return it.video_id == item.id && it.aweme_item_id > 0;
                  }
                );
            }
            console.log('dd', dd);
            if (dd.length == 0) {
              select_list.push(item);
            }
          } else if (item.source == 'QIANCHUAN') {
            let dd = [];
            if (
              this.order_detail.multi_product_creative_list[0].video_material
            ) {
              dd =
                this.order_detail.multi_product_creative_list[0].video_material.filter(
                  function (it) {
                    return it.video_id == item.id && it.aweme_item_id == 0;
                  }
                );
            }
            if (dd.length == 0) {
              select_list.push(item);
            }
          } else if (item.source == 'LIANSHAN') {
            select_list.push(item);
          }
        }
        console.log('select_list-----------', select_list);
        if (select_list.length == 0) {
          this.$message.error('过滤完无可用素材');
          return;
        }
        //判断是否有抖音下素材或者是否有标题素材
        // Modal.confirm({
        //   title: '删除提醒',
        //   content: '已过滤重复素材，是否确定向该计划下追加【'+select_list.length+'】条素材？',
        //   onOk: () => {
        //     this.addMaterialAction(select_list)
        //   },
        // });
        this.select_list = select_list;
        this.titleModalVisible = true;
        this.titleInput = '';
        this.titleList = [];
      } else {
        this.$message.error('请选择视频');
      }
    },
    handleTitleInput(e) {
      this.titleInput = e.target.value;
      // 按行分割，去除空行
      this.titleList = this.titleInput
        .split('\n')
        .map((t) => t.trim())
        .filter((t) => t);
    },
    removeTitle(index) {
      this.titleList.splice(index, 1);
      // 同步回textarea
      this.titleInput = this.titleList.join('\n');
    },
    handleTitleModalOk() {
      // 这里可以将titleList提交到后端或做后续处理
      this.titleModalVisible = false;
    },
    async addMaterialAction() {
      // 校验标题唯一性和长度
      if (this.titleList.length > 0) {
        // 检查重复
        const titleSet = new Set(this.titleList);
        if (titleSet.size !== this.titleList.length) {
          Modal.error({
            title: '提示',
            content: '存在重复的创意标题，请检查并去重！',
            zIndex: 1000002,
          });
          return;
        }
        // 检查长度
        for (let title of this.titleList) {
          if (strLength(title) < 10 || strLength(title) > 110) {
            Modal.error({
              title: '提示',
              content: '每个创意标题长度必须为5-55个字符！',
              zIndex: 1000002,
            });
            return;
          }
        }
      }
      const that = this;
      this.addloading = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.ADD_QY_AD_MATERIAL}`,
        method: 'POST',
        params: {
          advertiser_id: that.advertiser_id,
          ad_id: that.order_detail.ad_id,
          marketing_goal: that.order_detail.marketing_goal,
          select_list: JSON.stringify(this.select_list),
          titleList: this.titleList.length > 0 ? this.titleList : '',
          aweme_id: that.order_detail.aweme_id,
          aweme_name: that.ad?.room_info[0]?.anchor_name,
          aweme_avatar: that.ad?.room_info[0]?.anchor_avatar,
          product_id: that.ad.product_info[0].product_id,
          product_name: that.ad.product_info[0].product_name,
          product_img: that.ad.product_info[0].product_image,
        },
      });
      this.addloading = false;
      if (code == 0) {
        that.$message.error(msg);
        return;
      }
      this.resultvisible = true;
      this.videoVisible = false;
      this.titleModalVisible = false;
    },
    closeAddDrawer() {
      this.videoVisible = false;
    },
    deleteMaterial(e) {
      const that = this;
      Modal.confirm({
        title: '删除提醒',
        content: '是否确定删除素材？',
        onOk: async () => {
          await that.deleteMaterialAction(e);
        },
      });
    },
    async deleteMaterialAction(e) {
      const that = this;
      let opt_status = 'DELETE';
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.STOP_QY_AD_MATERIAL}`,
        method: 'POST',
        params: {
          advertiser_id: that.advertiser_id,
          ad_id: that.ad_id,
          material_type: that.material_type,
          material_id: e.material_id,
        },
      });
      if (code == 0) {
        that.$message.error(msg);
        return;
      }
      that.$message.success(msg);
      that.getAdMaterial();
    },
    fissionMaterial(record) {
      // 打开裂变策略配置弹窗
      this.currentFissionMaterial = record;
      this.isBatchFissionMode = false;
      this.batchFissionMaterials = [];
      this.fissionStrategyModalVisible = true;
    },
    // 批量裂变
    batchFissionMaterial() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请先选择要裂变的素材');
        return;
      }
      
      // 获取选中的素材
      const selectedMaterials = this.selectedRowKeys.map(index => {
        return this.material_data[index];
      }).filter(item => (item != null && item.stat_cost_for_roi2 > 10));
      
      if (selectedMaterials.length === 0) {
        this.$message.warning('未找到选中的素材且消耗大于10的素材');
        return;
      }
      
      // 检查选中的素材是否都有必要的字段
      const validMaterials = selectedMaterials.filter(item => {
        if (!item.material_id) {
          return false;
        }
        if (!item.product_info || !item.product_info[0] || !item.product_info[0].product_id) {
          return false;
        }
        return true;
      });
      
      if (validMaterials.length === 0) {
        this.$message.error('选中的素材缺少必要信息，无法进行裂变');
        return;
      }
      
      if (validMaterials.length < selectedMaterials.length) {
        this.$message.warning(`有 ${selectedMaterials.length - validMaterials.length} 个素材缺少必要信息，将只对 ${validMaterials.length} 个有效素材进行裂变`);
      }
      
      // 设置为批量裂变模式
      this.isBatchFissionMode = true;
      this.batchFissionMaterials = validMaterials;
      this.currentFissionMaterial = null;
      this.fissionStrategyModalVisible = true;
    },
    // 处理策略变更
    handleFissionStrategyChange(strategyName, checked) {
      const newValue = checked ? 1 : 0;
      this.fissionStrategy[strategyName] = newValue;
      
      // 检查冲突策略
      if (newValue === 1) {
        this.checkFissionStrategyConflicts(strategyName);
      }
    },
    // 检查策略冲突
    checkFissionStrategyConflicts(activeStrategy) {
      const conflicts = {
        clip_replace: ['robot_replace'],
        robot_replace: ['clip_replace'],
        hot_pre_video: ['pre_video_clip_replace'],
        pre_video_clip_replace: ['hot_pre_video'],
        derive_from_chosen_hot_mid: ['derive_from_industry_hot_pattern'],
        derive_from_industry_hot_pattern: ['derive_from_chosen_hot_mid'],
      };
      
      const conflictingStrategies = conflicts[activeStrategy] || [];
      conflictingStrategies.forEach(conflictStrategy => {
        if (this.fissionStrategy[conflictStrategy] === 1) {
          this.fissionStrategy[conflictStrategy] = 0;
          this.$message.warning(`已自动关闭冲突策略：${this.getFissionStrategyName(conflictStrategy)}`);
        }
      });
    },
    // 获取策略名称
    getFissionStrategyName(strategyKey) {
      const names = {
        clip_replace: '分镜替换',
        robot_replace: '人物替换',
        hot_pre_video: '爆款开头',
        pre_video_clip_replace: '前贴扩写',
        derive_from_chosen_hot_mid: '自有爆款套路',
        derive_from_industry_hot_pattern: '行业爆款套路',
      };
      return names[strategyKey] || strategyKey;
    },
    // 应用推荐策略
    applyRecommendedFissionStrategy() {
      this.fissionStrategy = {
        clip_replace: 1,
        hot_pre_video: 1,
        mix_cut: 1,
        pre_video_clip_replace: 1,
        raw_material_replace: 1,
        derive_from_chosen_hot_mid: 1,
        derive_from_industry_hot_pattern: 0,
        robot_replace: 0,
      };
      this.$message.success('已应用推荐策略组合');
    },
    // 验证裂变策略组合
    validateFissionStrategy() {
      const strategies = Object.values(this.fissionStrategy);
      const activeStrategies = strategies.filter(val => val === 1);
      
      if (activeStrategies.length === 0) {
        return { valid: false, message: '请至少选择一种裂变策略' };
      }
      
      return { valid: true, message: '' };
    },
    // 确认裂变策略
    async confirmFissionStrategy() {
      // 验证策略
      const strategyValidation = this.validateFissionStrategy();
      if (!strategyValidation.valid) {
        this.$message.error(strategyValidation.message);
        return;
      }

      // 批量裂变模式
      if (this.isBatchFissionMode) {
        if (!this.batchFissionMaterials || this.batchFissionMaterials.length === 0) {
          this.$message.error('未找到要裂变的素材');
          return;
        }
        
        this.fissionStrategyLoading = true;
        try {
          await this.batchFissionMaterialAction();
        } finally {
          this.fissionStrategyLoading = false;
        }
        return;
      }

      // 单个裂变模式
      if (!this.currentFissionMaterial) {
        this.$message.error('素材信息丢失，请重试');
        return;
      }

      this.fissionStrategyLoading = true;
      try {
        await this.fissionMaterialAction(this.currentFissionMaterial);
      } finally {
        this.fissionStrategyLoading = false;
      }
    },
    // 取消裂变策略
    cancelFissionStrategy() {
      this.fissionStrategyModalVisible = false;
      this.currentFissionMaterial = null;
      this.isBatchFissionMode = false;
      this.batchFissionMaterials = [];
    },
    async fissionMaterialAction(record) {
      const that = this;
      try {
        const { code, msg } = await requestHttp({
          api: `${qcApi.FISION_MATERIAL}`,
          method: 'POST',
          params: {
            advertiser_id: that.advertiser_id,
            ad_id: that.ad_id,
            material_id: record.material_id,
            fission_strategy: JSON.stringify(that.fissionStrategy),
            product_id: record.product_info[0].product_id,
          },
        });
        if (code == 0) {
          that.$message.error(msg || '裂变失败');
          return;
        }
        that.$message.success(msg || '裂变成功');
        // 关闭弹窗
        that.fissionStrategyModalVisible = false;
        that.currentFissionMaterial = null;
        that.isBatchFissionMode = false;
        that.batchFissionMaterials = [];
        // 刷新素材列表
        that.getAdMaterial();
      } catch (error) {
        console.error('裂变素材失败:', error);
        that.$message.error('裂变失败，请重试');
      }
    },
    // 批量裂变执行
    async batchFissionMaterialAction() {
      const that = this;
      if (!that.batchFissionMaterials || that.batchFissionMaterials.length === 0) {
        that.$message.error('没有要裂变的素材');
        return;
      }

      try {
        that.$message.loading(`正在批量裂变 ${that.batchFissionMaterials.length} 个素材...`, 0);
        
        // 批量执行裂变，使用 Promise.allSettled 确保所有请求都完成
        const promises = that.batchFissionMaterials.map((record, index) => {
          // 再次验证素材信息
          if (!record.material_id) {
            return Promise.reject(new Error(`素材 ${index + 1} 缺少 material_id`));
          }
          if (!record.product_info || !record.product_info[0] || !record.product_info[0].product_id) {
            return Promise.reject(new Error(`素材 ${index + 1} 缺少商品信息`));
          }
          
          return requestHttp({
            api: `${qcApi.FISION_MATERIAL}`,
            method: 'POST',
            params: {
              advertiser_id: that.advertiser_id,
              ad_id: that.ad_id,
              material_id: record.material_id,
              fission_strategy: JSON.stringify(that.fissionStrategy),
              product_id: record.product_info[0].product_id,
            },
          }).catch(error => {
            // 捕获请求错误，返回失败结果
            return { code: 0, msg: error.message || '请求失败' };
          });
        });

        const results = await Promise.allSettled(promises);
        that.$message.destroy(); // 关闭加载提示

        // 统计结果
        const successCount = results.filter(result => {
          if (result.status === 'rejected') {
            return false;
          }
          // code !== 0 表示成功（与单个裂变逻辑一致）
          return result.value && result.value.code !== 0;
        }).length;
        const failCount = results.length - successCount;

        if (successCount > 0) {
          that.$message.success(`成功裂变 ${successCount} 个素材`);
          
          if (failCount > 0) {
            that.$message.warning(`${failCount} 个素材裂变失败`);
          }
          
          // 关闭弹窗
          that.fissionStrategyModalVisible = false;
          that.isBatchFissionMode = false;
          that.batchFissionMaterials = [];
          
          // 清空选中状态
          that.selectedRowKeys = [];
          
          // 刷新素材列表
          that.getAdMaterial();
        } else {
          that.$message.error('所有素材裂变失败，请检查后重试');
        }
      } catch (error) {
        that.$message.destroy(); // 关闭加载提示
        console.error('批量裂变失败:', error);
        that.$message.error('批量裂变失败，请重试');
      }
    },
    handleTableChange(e, filters, sorter) {
      console.log('点击了', sorter);

      // 检查排序条件是否发生变化
      const sortChanged =
        sorter.order &&
        (this.sort !== sorter.order || this.sortby !== sorter.columnKey);

      // 设置排序参数
      if (sorter.order) {
        this.sort = sorter.order;
        this.sortby = sorter.columnKey;
      } else {
        this.sort = 'descend';
        this.sortby = 'material_id';
      }

      // 只有在排序条件改变时才重置页码
      if (sortChanged) {
        this.page = 1;
        this.pagination = {
          ...e,
          current: 1,
        };
      } else {
        // 正常分页逻辑
        this.page = e.current;
        this.pagination = e;
      }

      this.pagesize = e.pageSize;
      this.getAdMaterial();
    },
    handleStatusChange(e) {
      this.material_status = e;
      this.page = 1;
      this.material_data = [];
      this.getAdMaterial();
    },
    onTimeChange(e, date) {
      this.range_date = date;
      this.page = 1;
      this.material_data = [];
      this.getAdMaterial();
    },
    onAdTimeChange(e, date) {
      this.ad_range_date = date;
      this.getData(true);
      // 更新趋势图数据
      if (date && date.length > 0 && this.ad && this.ad.ad_info) {
        this.echartOrder();
      }
    },
    // 复制操作
    text_copy(context) {
      navigator.clipboard
        .writeText(context)
        .then(() => {
          this.$message.success('复制成功');
        })
        .catch((err) => {
          this.$message.error('复制失败');
        });
    },
    get_live_schedule_type(type) {
      let live_schedule_type = '';
      switch (type) {
        case 'SCHEDULE_FROM_NOW':
          live_schedule_type = '从今天起长期投放';
          break;
        case 'SCHEDULE_START_END':
          live_schedule_type = '设置开始和结束日期';
          break;
        case 'SCHEDULE_TIME_FIXEDRANGE':
          live_schedule_type = '固定时长';
          break;
        default:
          break;
      }
      return live_schedule_type;
    },
    getStatusName(status) {
      const statusItem = this.statusData.find((item) => item.value === status);
      return statusItem ? statusItem.name : status;
    },
    async getAdDetail(e) {
      this.detailTab = '1';
      this.ad_id = e.ad_info.id;
      this.ad_log_pagination = {
        ...this.ad_log_pagination,
        current: 1,
        total: 0,
      };
      this.log_data = [];
      this.orderDrawer = true;
      this.spinning_detail = true;
      console.log('参数', e);
      this.ad = e;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QY_AD_DETAIL}`,
        method: 'POST',
        params: {
          advertiser_id: e.advertiser_id,
          ad_id: e.ad_info.id,
        },
      });
      this.spinning_detail = false;
      if (code == 0) {
        this.orderDrawer = false;
        this.$message.error(msg);
        return;
      }
      this.order_detail = data;
      this.getData();
      // 初始化趋势数据
      this.initAdEchart();
    },
    initAdEchart() {
      // 初始化趋势数据
      if (this.ad && this.ad.ad_info) {
        this.adlineChartData.yAxis1 = this.adyAxis1options[0].label;
        this.adyAxis1name = this.adyAxis1options[0].name;
        this.adlineChartData.yAxis2 = this.adyAxis2options[1].label;
        this.adyAxis2name = this.adyAxis2options[1].name;
        this.echartOrder();
      }
    },
    onAdTrendDayChange(e, dateString) {
      this.adTrendDate = dateString;
      if (this.ad && this.ad.ad_info) {
        this.echartOrder();
      }
    },
    adchangeAxis1(val) {
      this.adlineChartData.yAxis1 = this.adyAxis1options[val].label;
      this.adyAxis1name = this.adyAxis1options[val].name;
      this.adyAxis2options.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      this.echartOrder();
    },
    adchangeAxis2(val) {
      this.adlineChartData.yAxis2 = this.adyAxis2options[val].label;
      this.adyAxis2name = this.adyAxis2options[val].name;
      this.adyAxis1options.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      this.echartOrder();
    },
    async echartOrder() {
      if (!this.ad || !this.ad.ad_info) {
        return;
      }
      this.adloading = true;
      
      // 优先使用时间范围，如果没有时间范围则使用单个日期
       let start_date = this.ad_range_date[0];
       let end_date = this.ad_range_date[1];
      
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QY_AD_REPORT_ECHART}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          ad_id: this.ad.ad_info.id,
          order_create_time: this.order_detail?.create_time,
          y1: this.adyAxis1name,
          y2: this.adyAxis2name,
          start_date: start_date || '',
          end_date: end_date || '',
        },
      });
      this.adloading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      this.adlineChartData.xAxisdata = data.x || [];
      this.adlineChartData.actualData = data.y1 || [];
      this.adlineChartData.expectedData = data.y2 || [];
      this.adtableData = data.list || [];
    },
    async getData(isdetail = false) {
      this.spinning = true;
      let start_date = '';
      let end_date = '';
      if (isdetail) {
        start_date = this.ad_range_date[0] ? this.ad_range_date[0] : '';
        end_date = this.ad_range_date[1] ? this.ad_range_date[1] : '';
      } else {
        start_date = this.range_date[0] ? this.range_date[0] : '';
        end_date = this.range_date[1] ? this.range_date[1] : '';
      }
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QY_AD_LIST}`,
        method: 'POST',
        params: {
          start_date: start_date,
          end_date: end_date,
          advertiser_id: this.advertiser_id,
          marketing_goal: 'VIDEO_PROM_GOODS',
          search_keyword: this.order_detail.ad_id,
          page: 1,
          pagesize: 10,
          smart_bid_type: this.order_detail?.delivery_setting?.smart_bid_type,
          search_keyword_type: 'AD',
        },
      });
      this.spinning = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      this.adlist = data.ad_list;
    },
    async getAdLogs() {
      // 以本次请求页码为准同步分页高亮（部分接口 page_info.page 恒为 1 或与请求不一致会导致 UI 跳回第一页）
      const reqPage = this.ad_log_pagination.current;
      const reqPageSize = this.ad_log_pagination.pageSize;
      this.spinning_detail = true;
      try {
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.QC_GET_AD_LOGS}`,
          method: 'POST',
          params: {
            advertiser_id: this.advertiser_id,
            ad_id: this.ad_id,
            page: reqPage,
            pagesize: reqPageSize,
          },
        });
        if (code == 0) {
          this.$message.error(msg);
          return;
        }
        if (!data) {
          this.log_data = [];
          return;
        }
        this.log_data = data.logs || [];
        const pi = data.page_info || {};
        const apiPage = pi.page != null ? Number(pi.page) : null;
        const apiPageSize =
          pi.page_size != null ? Number(pi.page_size) : null;
        // 仅当接口返回的页码与请求一致时才采用（否则仍以请求页为准，避免高亮错位）
        const nextCurrent =
          apiPage != null && !Number.isNaN(apiPage) && apiPage === reqPage
            ? apiPage
            : reqPage;
        this.ad_log_pagination = {
          ...this.ad_log_pagination,
          current: nextCurrent,
          pageSize:
            apiPageSize != null && !Number.isNaN(apiPageSize)
              ? apiPageSize
              : reqPageSize,
          total:
            pi.total_number != null ? Number(pi.total_number) || 0 : 0,
        };
      } finally {
        this.spinning_detail = false;
      }
    },
    handleAdLogTableChange(pagination) {
      if (!pagination) return;
      const nextCurrent =
        pagination.current != null
          ? pagination.current
          : this.ad_log_pagination.current;
      const nextPageSize =
        pagination.pageSize != null
          ? pagination.pageSize
          : this.ad_log_pagination.pageSize;
      this.ad_log_pagination = {
        ...this.ad_log_pagination,
        current: nextCurrent,
        pageSize: nextPageSize,
      };
      this.getAdLogs();
    },
    handleMaterialTypeChange(e) {
      this.material_type = e.target.value;
      this.page = 1;
      this.material_data = [];
      this.getAdMaterial();
    },
    async getAdMaterial() {
      this.spinning_detail = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QY_GET_AD_MATERIAL}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          ad_id: this.ad_id,
          marketing_goal: this.order_detail.marketing_goal,
          aweme_id: this.order_detail.aweme_id,
          material_type: this.material_type,
          search_keyword: this.search_keyword,
          material_status: this.material_status,
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
          sortby: this.sortby,
          sort: this.sort,
          page: this.page,
          pagesize: 100,
          analysis_type: this.analysis_type,
        },
      });
      this.spinning_detail = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (this.analysis_type == 'MATERIAL_SUGGEST') {
        if (data.ad_material_infos.length > 0) {
          this.material_data = [
            ...this.material_data,
            ...data.ad_material_infos,
          ];
          this.page++;
          this.getAdMaterial();
        } else {
          this.pagination.total = this.material_data.length;
        }
      } else {
        this.material_data = data.ad_material_infos;
        this.pagination.total = data.page_info.total_number;
      }
    },
    async getAdProduct() {
      this.spinning_detail = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QY_AD_PRODUCT_LIST}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          ad_id: this.ad_id,
          marketing_goal: this.order_detail.marketing_goal,
          aweme_id: this.order_detail.aweme_id,
          search_keyword: this.product_search_keyword,
          product_status: this.product_status,
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
          sortby: this.product_sortby,
          sort: this.product_sort,
          page: this.product_page,
          pagesize: 100,
        },
      });
      this.spinning_detail = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      // 根据实际返回的数据结构处理数据
      this.product_data = data.product_list || [];
      this.product_pagination.total = data.page_info?.total_number || 0;
    },
    async getUserLog() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_USER_LOGLIST}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          other_id: this.order_detail.ad_id,
          page: 1,
          pagesize: 100,
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      this.user_log_data = data.list;
    },
    async getMonitorLog() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QY_MONITOR_LOG_LIST}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          order_id: this.order_detail.ad_id,
          page: 1,
          pagesize: 100,
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      this.monitor_log_data = data.list;
    },
    changeDetailTopTab(e) {
      this.detailTab = e;
      if (e == 2) {
        this.page = 1;
        this.material_data = [];
        this.analysis_type = '';
        this.getAdMaterial();
      } else if (e == 4) {
        this.getAdLogs();
      } else if (e == 6) {
        this.getUserLog();
      } else if (e == 7) {
        this.getMonitorLog();
      } else if (e == 8) {
        this.product_page = 1;
        this.product_data = [];
        this.getAdProduct();
      }
    },
    handleProductTableChange(e, filters, sorter) {
      console.log('商品表格点击了', sorter);

      // 检查排序条件是否发生变化
      const sortChanged =
        sorter.order &&
        (this.product_sort !== sorter.order || this.product_sortby !== sorter.columnKey);

      // 设置排序参数
      if (sorter.order) {
        this.product_sort = sorter.order;
        this.product_sortby = sorter.columnKey;
      } else {
        this.product_sort = 'descend';
        this.product_sortby = 'product_id';
      }

      // 只有在排序条件改变时才重置页码
      if (sortChanged) {
        this.product_page = 1;
        this.product_pagination = {
          ...e,
          current: 1,
        };
      } else {
        // 正常分页逻辑
        this.product_page = e.current;
        this.product_pagination = e;
      }

      this.product_pagesize = e.pageSize;
      this.getAdProduct();
    },
    handleProductStatusChange(e) {
      this.product_status = e;
      this.product_page = 1;
      this.product_data = [];
      this.getAdProduct();
    },
    onProductTimeChange(e, date) {
      this.range_date = date;
      this.product_page = 1;
      this.product_data = [];
      this.getAdProduct();
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    onProductSelectChange(selectedRowKeys, selectedRows) {
      this.selectedProductRowKeys = selectedRowKeys;
      this.selectedProductRows = selectedRows;
    },
    deleteProduct(e) {
      const that = this;
      Modal.confirm({
        title: '删除提醒',
        content: '是否确定删除商品？',
        onOk: async () => {
          await that.deleteProductAction(e);
        },
      });
    },
    async deleteProductAction(e) {
      const that = this;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.DEL_QY_AD_PRODUCT}`,
        method: 'POST',
        params: {
          advertiser_id: that.advertiser_id,
          ad_id: that.ad_id,
          material_type: 'PRODUCT',
          product_id: e.product_info?.product_id,
        },
      });
      if (code == 0) {
        that.$message.error(msg);
        return;
      }
      that.$message.success(msg);
      that.getAdProduct();
    },
    async batchDeleteProduct() {
      if (!this.selectedProductRows.length) return;
      const that = this;
      Modal.confirm({
        title: '批量删除提醒',
        content: `是否确定批量删除选中的${this.selectedProductRows.length}个商品？`,
        onOk: async () => {
          for (let row of that.selectedProductRows) {
            // 只删除未被标记为已删除的
            if (!row?.is_del) {
              await that.deleteProductAction(row);
            }
          }
          that.selectedProductRowKeys = [];
          that.selectedProductRows = [];
        },
      });
    },
    async batchDeleteMaterial() {
      if (!this.selectedRows.length) return;
      const that = this;
      Modal.confirm({
        title: '批量删除提醒',
        content: `是否确定批量删除选中的${this.selectedRows.length}个创意？`,
        onOk: async () => {
          for (let row of that.selectedRows) {
            // 只删除未被标记为DELETED的
            if (row?.info?.material_status !== 'DELETED') {
              await that.deleteMaterialAction(row);
            }
          }
          that.selectedRowKeys = [];
          that.selectedRows = [];
        },
      });
    },
    // 补商品相关方法
    addProductAction() {
      this.addProductDrawerVisible = true;
      this.add_product_page = 1;
      this.add_product_list_data = [];
      this.add_product_selectedRowKeys = [];
      this.add_product_selectedRows = [];
      this.add_product_search_ids = '';
      this.add_product_search_name = '';
      this.getAddProductList();
    },
    // 关闭确认商品弹窗
    closeAddProductConfirmModal() {
      this.addProductConfirmModalVisible = false;
      // 关闭弹窗后刷新商品列表
      this.getAdProduct();
    },
    closeAddProductDrawer() {
      // 重置所有状态
      this.addProductConfirmModalVisible = false;
      this.addProductOriginList = [];
      this.addProductPcList = [];
      this.addProductPcListVisible = false;
      this.addProductYongjing = 0;
      this.addProductDiyong = 0;
      this.addProductIswg = 0;
      this.addProductDiyongCommissionRate = 1;
      this.addProductDrawerVisible = false;
      // 重置筛选条件
      this.add_product_filterModalVisible = false;
      this.add_product_selectedPriceRange = '不限';
      this.add_product_selectedCommissionRange = '不限';
      this.add_product_priceRange.min = null;
      this.add_product_priceRange.max = null;
      this.add_product_commissionRange.min = null;
      this.add_product_commissionRange.max = null;
      this.add_product_origin_list_data = [];
    },
    searchAddProductList() {
      this.add_product_page = 1;
      this.add_product_list_data = [];
      this.add_product_origin_list_data = [];
      // 重置筛选条件
      this.add_product_selectedPriceRange = '不限';
      this.add_product_selectedCommissionRange = '不限';
      this.add_product_priceRange.min = null;
      this.add_product_priceRange.max = null;
      this.add_product_commissionRange.min = null;
      this.add_product_commissionRange.max = null;
      this.getAddProductList();
    },
    async getAddProductList() {
      this.add_product_loading = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QC_PRODUCT_LIST_QY}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          aweme_id: this.order_detail.aweme_id || '',
          page: this.add_product_page,
          sort: this.add_product_sort,
          sortby: this.add_product_sortby,
          product_ids: this.add_product_search_ids,
          product_name: this.add_product_search_name,
          tab: 'ALL',
          create_roi2_limit_product: 1, // 获取未投放商品
        },
      });
      this.add_product_loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (data.is_gf == 1) {
        this.add_product_origin_list_data = data.product_list || [];
        this.filterAddProductList();
        this.add_product_pagination.total = data.page_info?.total_number || 0;
      } else {
        if (data.product_list && data.product_list.length > 0) {
          this.add_product_origin_list_data = [
            ...this.add_product_origin_list_data,
            ...data.product_list,
          ];
          this.filterAddProductList();
          this.add_product_pagination.total = this.add_product_list_data.length;
        } else {
          this.filterAddProductList();
          this.add_product_pagination.total = this.add_product_list_data.length;
        }
      }
    },
    handleAddProductTableChange(e, filters, sorter) {
      // 检查排序条件是否发生变化
      const sortChanged =
        sorter.order &&
        (this.add_product_sort !== sorter.order ||
          this.add_product_sortby !== sorter.columnKey);

      // 设置排序参数
      if (sorter.order) {
        this.add_product_sort = sorter.order;
        this.add_product_sortby = sorter.columnKey;
      } else {
        this.add_product_sort = 'descend';
        this.add_product_sortby = 'audit_time';
      }

      // 只有在排序条件改变时才重置页码
      if (sortChanged) {
        this.add_product_page = 1;
        this.add_product_pagination = {
          ...e,
          current: 1,
        };
      } else {
        // 正常分页逻辑
        this.add_product_page = e.current;
        this.add_product_pagination = e;
      }

      this.add_product_pagesize = e.pageSize;
      this.getAddProductList();
    },
    onAddProductSelectChange(selectedRowKeys, selectedRows) {
      this.add_product_selectedRowKeys = selectedRowKeys;
      this.add_product_selectedRows = selectedRows;
    },
    // 筛选相关方法
    showAddProductFilterModal() {
      this.add_product_filterModalVisible = true;
    },
    toggleAddProductPriceSection() {
      this.add_product_priceSectionExpanded = !this.add_product_priceSectionExpanded;
    },
    toggleAddProductCommissionSection() {
      this.add_product_commissionSectionExpanded = !this.add_product_commissionSectionExpanded;
    },
    selectAddProductPriceRange(value) {
      this.add_product_selectedPriceRange = value;
      if (value === '不限') {
        this.add_product_priceRange.min = null;
        this.add_product_priceRange.max = null;
      } else if (value === '500+') {
        this.add_product_priceRange.min = 500;
        this.add_product_priceRange.max = null;
      } else {
        const [min, max] = value.split('-').map(Number);
        this.add_product_priceRange.min = min;
        this.add_product_priceRange.max = max;
      }
    },
    selectAddProductCommissionRange(value) {
      this.add_product_selectedCommissionRange = value;
      if (value === '不限') {
        this.add_product_commissionRange.min = null;
        this.add_product_commissionRange.max = null;
      } else if (value === '50+') {
        this.add_product_commissionRange.min = 50;
        this.add_product_commissionRange.max = null;
      } else {
        const [min, max] = value.split('-').map(Number);
        this.add_product_commissionRange.min = min;
        this.add_product_commissionRange.max = max;
      }
    },
    applyAddProductFilter() {
      this.add_product_selectedRowKeys = [];
      this.add_product_selectedRows = [];
      // 防抖处理，避免频繁筛选
      if (this.add_product_filterTimeout) {
        clearTimeout(this.add_product_filterTimeout);
      }
      
      this.add_product_filterTimeout = setTimeout(() => {
        this._performAddProductFilter();
      }, 100);
    },
    _performAddProductFilter() {
      const minPrice = this.add_product_priceRange.min;
      const maxPrice = this.add_product_priceRange.max;
      const minCos = this.add_product_commissionRange.min;
      const maxCos = this.add_product_commissionRange.max;

      const filteredData = [];
      const dataLength = this.add_product_origin_list_data.length;
      
      // 使用 for 循环替代 filter，性能更好
      for (let i = 0; i < dataLength; i++) {
        const item = this.add_product_origin_list_data[i];
        const price = parseFloat(item.price) || 0;
        const cos = parseFloat(item.cos_ratio) || 0;

        // 早期退出优化：一旦条件不满足就跳过
        if (minPrice !== null && price < minPrice) continue;
        if (maxPrice !== null && price > maxPrice) continue;
        if (minCos !== null && cos < minCos) continue;
        if (maxCos !== null && cos > maxCos) continue;

        filteredData.push(item);
      }

      this.add_product_list_data = filteredData;
      this.add_product_pagination.total = filteredData.length;
      this.add_product_pagination.current = 1;
      this.add_product_page = 1;
      this.add_product_filterModalVisible = false;
      this.$message.success('筛选已应用');
    },
    cancelAddProductFilter() {
      this.add_product_filterModalVisible = false;
      // 重置筛选条件
      this.add_product_selectedPriceRange = '不限';
      this.add_product_selectedCommissionRange = '不限';
      this.add_product_priceRange.min = null;
      this.add_product_priceRange.max = null;
      this.add_product_commissionRange.min = null;
      this.add_product_commissionRange.max = null;
    },
    // 筛选商品列表（按佣金率和售价）
    filterAddProductList() {
      let filteredList = [...this.add_product_origin_list_data];

      // 按佣金率筛选
      if (this.add_product_commissionRange.min !== null && this.add_product_commissionRange.min !== undefined) {
        filteredList = filteredList.filter((item) => {
          const commission = parseFloat(item.cos_ratio) || 0;
          return commission >= this.add_product_commissionRange.min;
        });
      }
      if (this.add_product_commissionRange.max !== null && this.add_product_commissionRange.max !== undefined) {
        filteredList = filteredList.filter((item) => {
          const commission = parseFloat(item.cos_ratio) || 0;
          return commission <= this.add_product_commissionRange.max;
        });
      }

      // 按售价筛选
      if (this.add_product_priceRange.min !== null && this.add_product_priceRange.min !== undefined) {
        filteredList = filteredList.filter((item) => {
          const price = parseFloat(item.price) || 0;
          return price >= this.add_product_priceRange.min;
        });
      }
      if (this.add_product_priceRange.max !== null && this.add_product_priceRange.max !== undefined) {
        filteredList = filteredList.filter((item) => {
          const price = parseFloat(item.price) || 0;
          return price <= this.add_product_priceRange.max;
        });
      }

      this.add_product_list_data = filteredList;
      // 更新分页总数
      if (this.add_product_pagination) {
        this.add_product_pagination.total = filteredList.length;
      }
    },
    clearAddProductSelection() {
      this.add_product_selectedRowKeys = [];
      this.add_product_selectedRows = [];
    },
    // 单个商品加黑
    async handleAddProductBlack(record) {
      if (!record || !record.id) {
        this.$message.error('商品信息不完整');
        return;
      }

      try {
        // 设置加载状态
        this.$set(record, 'blacklisting', true);
        
        // 显示确认对话框
        const confirmed = await new Promise((resolve) => {
          this.$confirm({
            title: '确认加黑',
            content: `确定要将商品 "${record.name || record.id}" 加入黑名单吗？加入黑名单的商品将不会进行投放。`,
            okText: '确认加黑',
            cancelText: '取消',
            okType: 'danger',
            onOk: () => {
              // 显示输入备注的模态框
              this.add_product_singleBlackRecord = record;
              this.add_product_singleBlackModalVisible = true;
              resolve(true);
            },
            onCancel: () => resolve(false),
          });
        });
        
        if (!confirmed) {
          return;
        }
        
      } catch (error) {
        console.error('显示确认对话框失败:', error);
      } finally {
        this.$set(record, 'blacklisting', false);
      }
    },
    // 单个加黑确认（带备注）
    async handleSingleBlackConfirm() {
      if (!this.add_product_singleBlackRecord) {
        return;
      }
      
      const record = this.add_product_singleBlackRecord;
      const reason = this.add_product_singleBlackReason || '';
      
      try {
        this.$set(record, 'blacklisting', true);
        
        // 调用API将商品加入黑名单
        const { code, msg } = await requestHttp({
          api: `${qcApi.ADD_QY_BLACK_PRODUCT}`,
          method: 'POST',
          params: { 
            product_id: record.id,
            product_img: record.img || '',
            product_name: record.name || '',
            reason: reason
          }
        });
        
        if (code === 1) {
          this.$message.success(`商品 "${record.name || record.id}" 已成功加入黑名单`);
          
          // 从列表中移除该商品
          const index = this.add_product_list_data.findIndex(item => item.id === record.id);
          if (index !== -1) {
            this.add_product_list_data.splice(index, 1);
          }
          
          // 从选中列表中移除
          const selectedIndex = this.add_product_selectedRowKeys.indexOf(record.id);
          if (selectedIndex !== -1) {
            this.add_product_selectedRowKeys.splice(selectedIndex, 1);
          }
          
          // 更新分页总数
          if (this.add_product_pagination.total > 0) {
            this.add_product_pagination.total--;
          }
          
          // 关闭模态框
          this.add_product_singleBlackModalVisible = false;
          this.add_product_singleBlackRecord = null;
          this.add_product_singleBlackReason = '';
        } else {
          this.$message.error(msg || '加入黑名单失败');
        }
        
      } catch (error) {
        console.error('加入黑名单失败:', error);
        this.$message.error('加入黑名单失败，请重试');
      } finally {
        this.$set(record, 'blacklisting', false);
      }
    },
    // 单个加黑取消
    handleSingleBlackCancel() {
      this.add_product_singleBlackModalVisible = false;
      this.add_product_singleBlackRecord = null;
      this.add_product_singleBlackReason = '';
    },
    // 显示批量加黑模态框
    showAddProductBlackModal() {
      if (this.add_product_selectedRowKeys.length === 0) {
        this.$message.warning('请先选择要加黑的商品');
        return;
      }
      this.add_product_blackModalVisible = true;
      this.add_product_blackReason = '';
    },
    // 批量加黑模态框确认
    async handleAddProductBlackModalOk() {
      await this.batchAddProductToBlacklist(this.add_product_blackReason);
    },
    // 批量加黑模态框取消
    handleAddProductBlackModalCancel() {
      this.add_product_blackModalVisible = false;
      this.add_product_blackReason = '';
    },
    // 批量加入黑名单
    async batchAddProductToBlacklist(reason = '') {
      if (this.add_product_selectedRowKeys.length === 0) {
        this.$message.warning('没有可加入黑名单的商品');
        return;
      }

      try {
        this.add_product_blackLoading = true;
        this.$message.loading('正在批量加入黑名单...', 0);
        
        // 获取选中的商品数据
        const selectedProducts = this.add_product_list_data.filter(item => 
          this.add_product_selectedRowKeys.includes(item.id)
        );
        
        if (selectedProducts.length === 0) {
          this.$message.warning('未找到选中的商品');
          this.add_product_blackLoading = false;
          this.$message.destroy();
          return;
        }
        
        // 循环添加每个商品到黑名单
        const promises = selectedProducts.map(item => 
          requestHttp({
            api: `${qcApi.ADD_QY_BLACK_PRODUCT}`,
            method: 'POST',
            params: { 
              product_id: item.id,
              product_img: item.img || '',
              product_name: item.name || '',
              reason: reason || ''
            }
          })
        );

        const results = await Promise.allSettled(promises);
        const successCount = results.filter(result => 
          result.status === 'fulfilled' && result.value.code === 1
        ).length;
        const failCount = results.length - successCount;

        this.$message.destroy(); // 关闭加载提示

        if (successCount > 0) {
          this.$message.success(`成功将 ${successCount} 个商品加入黑名单`);
          
          // 从列表中移除已成功加入黑名单的商品
          const successIds = selectedProducts
            .filter((item, index) => 
              results[index].status === 'fulfilled' && results[index].value.code === 1
            )
            .map(item => item.id);
          
          this.add_product_list_data = this.add_product_list_data.filter(
            item => !successIds.includes(item.id)
          );
          
          // 清空选中列表
          this.add_product_selectedRowKeys = [];
          this.add_product_selectedRows = [];
          
          // 更新分页总数
          this.add_product_pagination.total = Math.max(0, this.add_product_pagination.total - successCount);
          
          if (failCount > 0) {
            this.$message.warning(`${failCount} 个商品加入黑名单失败，请检查后重试`);
          }
        } else {
          this.$message.error('所有商品加入黑名单失败');
        }
        
        // 关闭模态框
        this.add_product_blackModalVisible = false;
        this.add_product_blackReason = '';
      } catch (error) {
        this.$message.destroy(); // 关闭加载提示
        console.error('批量加入黑名单失败:', error);
        this.$message.error('批量加入黑名单失败，请重试');
      } finally {
        this.add_product_blackLoading = false;
      }
    },
    // 添加商品视频相关方法
    openAddProductVideo(record) {
      if (!record) {
        return;
      }
      // 检查是否有 aweme_id
      if (!record.aweme_id && !this.order_detail.aweme_id) {
        this.$message.error('该商品缺少抖音号信息，无法添加视频');
        return;
      }
      this.addProductVideoDrawerProduct = record;
      this.addProductVideoDrawerKey = {
        product_id: record.id,
        aweme_id: record.aweme_id || this.order_detail.aweme_id || '',
      };
      this.addProductVideoDrawerSelectList = Array.isArray(record.video_list)
        ? [...record.video_list]
        : [];
      this.addProductVideoVisible = true;
    },
    closeAddProductVideoDrawer() {
      this.addProductVideoVisible = false;
      this.addProductVideoDrawerProduct = null;
      this.addProductVideoDrawerKey = null;
      this.addProductVideoDrawerSelectList = [];
    },
    addProductVideoReceive(value) {
      if (!this.addProductVideoDrawerKey) {
        this.closeAddProductVideoDrawer();
        return;
      }
      const incomingList =
        value && Array.isArray(value.video_material_list)
          ? value.video_material_list
          : [];
      const targetIndex = this.findAddProductIndex(
        this.addProductVideoDrawerKey.product_id,
        this.addProductVideoDrawerKey.aweme_id,
        this.addProductOriginList
      );
      if (targetIndex === -1) {
        this.$message.error('未找到对应的商品，添加失败');
        this.closeAddProductVideoDrawer();
        return;
      }
      const formattedList = incomingList.map((video) => ({
        ...video,
        type: video.type || 'VIDEO',
        source: video.source || 'QIANCHUAN',
      }));
      const currentVideoList = Array.isArray(
        this.addProductOriginList[targetIndex].video_list
      )
        ? this.addProductOriginList[targetIndex].video_list
        : [];
      const mergedVideoList = this.mergeAddProductVideoMaterials(
        currentVideoList,
        formattedList
      );
      this.$set(this.addProductOriginList[targetIndex], 'video_list', mergedVideoList);
      this.$set(this.addProductOriginList[targetIndex], 'video_status', true);

      this.closeAddProductVideoDrawer();
    },
    mergeAddProductVideoMaterials(currentList = [], newList = []) {
      if (!newList.length) {
        return Array.isArray(currentList) ? currentList.slice() : [];
      }
      const newIds = new Set(
        newList
          .filter((item) => item && item.id)
          .map((item) => item.id)
      );
      const preservedCurrent = Array.isArray(currentList)
        ? currentList.filter((item) => !newIds.has(item.id))
        : [];
      return [...preservedCurrent, ...newList];
    },
    findAddProductIndex(productId, awemeId, list = this.addProductOriginList) {
      if (!Array.isArray(list)) {
        return -1;
      }
      return list.findIndex((item) => {
        if (!item) return false;
        const matchProduct = item.id === productId;
        const matchAweme =
          !awemeId || awemeId === '' || item.aweme_id === awemeId;
        return matchProduct && matchAweme;
      });
    },
    async confirmAddProduct() {
      if (this.add_product_selectedRows.length === 0) {
        this.$message.warning('请选择要添加的商品');
        return;
      }

      // 显示确认弹窗，将选中的商品复制到 originList
      this.addProductOriginList = this.add_product_selectedRows.map(item => ({
        ...item,
        video_list: [],
        video_status: false,
        aweme_id: this.order_detail.aweme_id || '',
      }));
      this.addProductPcList = [];
      // 重置过滤选项
      this.addProductFilterApplied = false; // 重置应用过滤标志
      this.addProductYongjing = 0;
      this.addProductDiyong = 0;
      this.addProductIswg = 0;
      this.addProductDiyongCommissionRate = 1;
      this.addProductIsGetDouyin = 1; // 默认选中抖音视频
      this.addProductIsGetDouyinTw = 0;
      this.addProductDixiao = 0;
      this.addProductPaichu = 0;
      this.addProductPaichuNo = 0;
      this.addProductConfirmModalVisible = true;
    },
    // 应用过滤（确认弹窗中的过滤）
    async applyAddProductOriginFilter() {
      this.addProductApplyLoading = true;
      
      // 如果需要拉取抖音视频，先拉取（但不在fetchAddProductDouyinVideos中设置loading，避免冲突）
      if (this.addProductIsGetDouyin == 1 || this.addProductIsGetDouyinTw == 1) {
        await this.fetchAddProductDouyinVideos(false);
      }
      
      let currentList = [...this.addProductOriginList];
      let originalCount = currentList.length;

      // 过滤无佣品
      if (this.addProductYongjing == 1) {
        const beforeCount = currentList.length;
        const excludedItems = currentList.filter((item) => !item.price || item.price === '');
        currentList = currentList.filter((item) => item.price && item.price !== '');
        
        excludedItems.forEach((item) => {
          this.addProductPcList.push({
            ...item,
            excludeReason: '无佣金商品',
          });
        });
      }

      // 过滤低佣品
      if (this.addProductDiyong == 1) {
        const beforeCount = currentList.length;
        const commissionThreshold = this.addProductDiyongCommissionRate || 1;
        const excludedItems = currentList.filter((item) => 
          !item.cos_ratio || parseFloat(item.cos_ratio) <= commissionThreshold
        );
        currentList = currentList.filter((item) => 
          item.cos_ratio && parseFloat(item.cos_ratio) > commissionThreshold
        );
        
        excludedItems.forEach((item) => {
          this.addProductPcList.push({
            ...item,
            excludeReason: '低佣品商品',
          });
        });
      }

      // 过滤违规词商品
      if (this.addProductIswg == 1) {
        const beforeCount = currentList.length;
        const excludedItems = currentList.filter((item) => {
          const productName = item.name || '';
          return forbiddenWords.some((word) => productName.includes(word));
        });
        currentList = currentList.filter((item) => {
          const productName = item.name || '';
          return !forbiddenWords.some((word) => productName.includes(word));
        });
        
        excludedItems.forEach((item) => {
          const productName = item.name || '';
          const matchedWords = forbiddenWords.filter((word) =>
            productName.includes(word)
          );
          this.addProductPcList.push({
            ...item,
            excludeReason: `违规词商品 (包含: ${matchedWords.join(', ')})`,
          });
        });
      }

      // 更新列表
      this.addProductOriginList = currentList;
      this.addProductApplyLoading = false;
      this.addProductFilterApplied = true; // 标记已点击应用过滤

      const excludedCount = originalCount - currentList.length;
      if (excludedCount > 0) {
        this.$message.success(`已排除 ${excludedCount} 个商品，剩余 ${currentList.length} 个商品`);
      } else {
        this.$message.info('没有商品被排除');
      }
    },
    // 拉取抖音视频
    async fetchAddProductDouyinVideos(setLoading = true) {
      if (!this.addProductIsGetDouyin && !this.addProductIsGetDouyinTw) {
        return;
      }

      if (setLoading) {
        this.addProductApplyLoading = true;
      }
      try {
        // 批量处理抖音视频获取
        if (this.addProductIsGetDouyin) {
          const douyinRequests = this.addProductOriginList.map(item => ({
            advertiser_id: this.advertiser_id,
            marketing_goal: 'VIDEO_PROM_GOODS',
            aweme_id: item.aweme_id || this.order_detail.aweme_id || '',
            product_id: item.id,
            page: '',
            dixiao: this.addProductDixiao,
          }));

          const { code, msg, data } = await requestHttp({
            api: `${qcApi.QC_AWEME_VIDEO_GET_BATCH}`,
            method: 'POST',
            params: {
              advertiser_id: this.advertiser_id,
              batch_requests: JSON.stringify(douyinRequests)
            },
          });
          
          if (code == 0) {
            this.$message.error(msg);
          } else if (data && Array.isArray(data)) {
            // 处理批量返回的数据
            data.forEach((result) => {
              const productIndex = this.addProductOriginList.findIndex(
                item => item.id === result.product_id
              );
              
              if (productIndex !== -1) {
                let douyinList = [];
                if (result.video_info && Array.isArray(result.video_info)) {
                  result.video_info.forEach((it) => {
                    it.id = it.aweme_item_id;
                    it.source = 'DOUYIN';
                    it.type = 'VIDEO';
                    it.image_mode = 'VIDEO_VERTICAL';
                    it.imageUrl = it.video_cover_url;
                  });
                  douyinList = result.video_info.filter((it) => it.duration < 301);
                }
                
                const currentVideoList = this.addProductOriginList[productIndex].video_list || [];
                const mergedVideoList = [...currentVideoList, ...douyinList];
                
                this.$set(this.addProductOriginList, productIndex, {
                  ...this.addProductOriginList[productIndex],
                  video_list: mergedVideoList,
                  video_status: true,
                });
              }
            });
          }
        }

        // 批量处理抖音图文获取
        if (this.addProductIsGetDouyinTw) {
          const douyinTwRequests = this.addProductOriginList.map(item => ({
            advertiser_id: this.advertiser_id,
            marketing_goal: 'VIDEO_PROM_GOODS',
            aweme_id: item.aweme_id || this.order_detail.aweme_id || '',
            product_id: item.id,
            page: '',
            dixiao: this.addProductDixiao,
          }));

          const { code, msg, data } = await requestHttp({
            api: `${qcApi.QC_AWEME_VIDEO_GET_BATCH_TW}`,
            method: 'POST',
            params: {
              advertiser_id: this.advertiser_id,
              batch_requests: JSON.stringify(douyinTwRequests)
            },
          });
          
          if (code == 0) {
            this.$message.error(msg);
          } else if (data && Array.isArray(data)) {
            // 处理批量返回的数据
            data.forEach((result) => {
              const productIndex = this.addProductOriginList.findIndex(
                item => item.id === result.product_id
              );
              
              if (productIndex !== -1) {
                let douyinTwList = [];
                if (result.image_aggregate_list && Array.isArray(result.image_aggregate_list)) {
                  result.image_aggregate_list.forEach((it) => {
                    it.id = it.aweme_carousel_id || it.aweme_item_id;
                    it.aweme_carousel_id = it.aweme_carousel_id || it.aweme_item_id; // 确保 aweme_carousel_id 存在
                    it.source = 'TW';
                    it.type = 'TW';
                  });
                  douyinTwList = result.image_aggregate_list;
                }
                
                const currentVideoList = this.addProductOriginList[productIndex].video_list.filter(
                  (it) => it.type != 'TW'
                ) || [];
                const mergedTwList = [...currentVideoList, ...douyinTwList];
                
                this.$set(this.addProductOriginList, productIndex, {
                  ...this.addProductOriginList[productIndex],
                  video_list: mergedTwList,
                  video_status: true,
                });
              }
            });
          }
        }

        // 应用视频相关的过滤
        if (this.addProductPaichu == 1) {
          const beforeCount = this.addProductOriginList.length;
          const excludedItems = this.addProductOriginList.filter((item) =>
            item.video_list && item.video_list.some((video) => video.is_dx === 1)
          );
          this.addProductOriginList = this.addProductOriginList.filter(
            (item) => !item.video_list || !item.video_list.some((video) => video.is_dx === 1)
          );
          
          excludedItems.forEach((item) => {
            this.addProductPcList.push({
              ...item,
              excludeReason: '低效视频商品',
            });
          });
        }

        // 排除无视频商品
        if (this.addProductPaichuNo == 1) {
          const beforeCount = this.addProductOriginList.length;
          const excludedItems = this.addProductOriginList.filter(
            (item) => !item.video_list || item.video_list.length === 0
          );
          this.addProductOriginList = this.addProductOriginList.filter(
            (item) => item.video_list && item.video_list.length > 0
          );
          
          excludedItems.forEach((item) => {
            this.addProductPcList.push({
              ...item,
              excludeReason: '无视频商品',
            });
          });
        }

        if (setLoading) {
          this.$message.success('抖音视频拉取完成');
        }
      } catch (error) {
        console.error('批量获取抖音视频失败:', error);
        this.$message.error('批量获取抖音视频失败');
      } finally {
        if (setLoading) {
          this.addProductApplyLoading = false;
        }
      }
    },
    // 构建商品创意素材列表
    buildMultiProductCreativeList(product) {
      const creativeList = {
        product_id: product.id,
        product_url: product.img || '', // 商品图片地址
        channel_id: product.channel_id || '',
        channel_type: product.channel_type || '',
      };

      // 如果有视频列表，构建 video_material 和 carousel_material
      if (product.video_list && product.video_list.length > 0) {
        const videoMaterials = [];
        const carouselMaterials = [];
        // 用于去重的 Set
        const videoMaterialIds = new Set(); // 用于抖音视频和千川视频去重
        const carouselMaterialIds = new Set(); // 用于抖音图文去重

        product.video_list.forEach((video) => {
          if (video.type === 'VIDEO' && video.source === 'DOUYIN') {
            // 抖音视频
            const awemeItemId = video.aweme_item_id || video.id;
            if (awemeItemId && !videoMaterialIds.has(awemeItemId)) {
              videoMaterialIds.add(awemeItemId);
              videoMaterials.push({
                image_mode: 'VIDEO_VERTICAL',
                aweme_item_id: awemeItemId,
              });
            }
          } else if (video.type === 'TW' && video.source === 'TW') {
            // 抖音图文
            const awemeCarouselId = video.aweme_carousel_id || video.id;
            if (awemeCarouselId && !carouselMaterialIds.has(awemeCarouselId)) {
              carouselMaterialIds.add(awemeCarouselId);
              carouselMaterials.push({
                aweme_carousel_id: awemeCarouselId,
              });
            }
          } else if (video.type === 'VIDEO' && video.source === 'QIANCHUAN') {
            // 千川视频（使用 video_id，但这里可能需要根据实际情况调整）
            const videoId = video.id;
            if (videoId && !videoMaterialIds.has(videoId)) {
              videoMaterialIds.add(videoId);
              videoMaterials.push({
                image_mode: video.image_mode || 'VIDEO_VERTICAL',
                video_id: videoId,
              });
            }
          }
        });

        if (videoMaterials.length > 0) {
          creativeList.video_material = videoMaterials;
        }
        if (carouselMaterials.length > 0) {
          creativeList.carousel_material = carouselMaterials;
        }

        // 如果有素材，设置创意类型
        if (videoMaterials.length > 0 || carouselMaterials.length > 0) {
          creativeList.creative_type = 'PROGRAMMATIC_CREATIVE';
        }
      }

      return creativeList;
    },
    // 最终确认添加
    async handleAddProductConfirmOk() {
      if (this.addProductOriginList.length === 0) {
        this.$message.warning('没有可添加的商品');
        return;
      }

      // 检查是否已点击应用过滤
      if (!this.addProductFilterApplied) {
        this.$message.warning('请先点击"应用过滤"按钮进行过滤操作');
        return;
      }

      this.addProductApplyLoading = true;
      try {
        // 构建批量商品创意列表
        const multiProductCreativeList = this.addProductOriginList.map((product) => {
          return this.buildMultiProductCreativeList(product);
        });

        // 批量提交所有商品
        const params = {
          advertiser_id: this.advertiser_id,
          ad_id: this.ad_id,
          multi_product_creative_list: JSON.stringify(multiProductCreativeList),
        };

        const result = await requestHttp({
          api: `${qcApi.ADD_QY_PRODUCT}`,
          method: 'POST',
          params: params,
        });

        if (result.code !== 0) {
          // 成功
          this.$message.success(`成功添加 ${this.addProductOriginList.length} 个商品`);
          // 刷新商品列表
          this.getAdProduct();
          // 关闭弹窗
          this.closeAddProductConfirmModal();
          this.closeAddProductDrawer();
          this.resultvisible = true;
        } else {
          // 失败
          this.$message.error(result.msg || '添加商品失败');
        }
      } catch (error) {
        console.error('添加商品失败:', error);
        this.$message.error('添加商品失败，请重试');
      } finally {
        this.addProductApplyLoading = false;
      }
    },
    // 删除选中商品
    delAddProductSelect(record) {
      this.addProductOriginList = this.addProductOriginList.filter((item) => {
        return item.id !== record.id;
      });
    },
    // 过滤选项变化
    onAddProductYjChange(e) {
      if (e.target.checked) {
        this.addProductYongjing = 1;
      } else {
        this.addProductYongjing = 0;
      }
    },
    onAddProductDyChange(e) {
      if (e.target.checked) {
        this.addProductDiyong = 1;
      } else {
        this.addProductDiyong = 0;
      }
    },
    onAddProductWgChange(e) {
      if (e.target.checked) {
        this.addProductIswg = 1;
      } else {
        this.addProductIswg = 0;
      }
    },
    onAddProductDouyinChange(e) {
      if (e.target.checked) {
        this.addProductIsGetDouyin = 1;
      } else {
        this.addProductIsGetDouyin = 0;
      }
    },
    onAddProductDouyinTwChange(e) {
      if (e.target.checked) {
        this.addProductIsGetDouyinTw = 1;
      } else {
        this.addProductIsGetDouyinTw = 0;
      }
    },
    onAddProductDxChange(e) {
      if (e.target.checked) {
        this.addProductDixiao = 1;
      } else {
        this.addProductDixiao = 0;
      }
      this.addProductPaichu = 0;
    },
    onAddProductPcChange(e) {
      if (e.target.checked) {
        this.addProductPaichu = 1;
      } else {
        this.addProductPaichu = 0;
      }
      this.addProductDixiao = 0;
    },
    onAddProductPcNoChange(e) {
      if (e.target.checked) {
        this.addProductPaichuNo = 1;
      } else {
        this.addProductPaichuNo = 0;
      }
    },
    showAddProductWgTip() {
      this.addProductWgTipVisible = true;
    },
    showAddProductPcList() {
      this.addProductPcListVisible = true;
    },
    // 恢复排除的商品
    restoreAddProductExcludedGood(record) {
      this.$set(record, 'restoring', true);
      
      // 将商品重新添加到列表中
      this.addProductOriginList.push({
        ...record,
        excludeReason: undefined,
        restoring: false,
      });
      
      // 从排除列表中移除
      const index = this.addProductPcList.findIndex(
        (item) => item.id === record.id
      );
      if (index !== -1) {
        this.addProductPcList.splice(index, 1);
      }
      
      this.$message.success(`商品 "${record.name}" 已恢复`);
      this.$set(record, 'restoring', false);
    },
    // 批量恢复所有排除的商品
    restoreAllAddProductExcludedGoods() {
      if (this.addProductPcList.length === 0) {
        this.$message.warning('没有可恢复的商品');
        return;
      }
      
      this.addProductRestoringAll = true;
      
      const restoreCount = this.addProductPcList.length;
      
      // 批量恢复所有商品
      this.addProductPcList.forEach((record) => {
        this.addProductOriginList.push({
          ...record,
          excludeReason: undefined,
        });
      });
      
      // 清空排除列表
      this.addProductPcList = [];
      
      this.$message.success(`已恢复 ${restoreCount} 个商品`);
      this.addProductRestoringAll = false;
    },
  },
};
</script>

<style lang="less" scoped>
.searchResult {
  .name {
    color: #333;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
  }
}

.aweme {
  display: flex;
  padding-left: 20px;
}

.aweme-right {
  text-align: left;
  padding-left: 10px;

  .aweme-title {
    color: #323335;
    // font-weight: bold;
    // margin-bottom: 5px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 180px;
  }
}

.small {
  font-size: 11px;
  line-height: 18px;
}

.tips {
  margin-bottom: 10px;
}

.showTemplate {
  .dataOverview {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 0;
  }

  .dataViewItem {
    flex: 1;
    margin-right: 0.5%;
    margin-left: 0.5%;
    border-radius: 15px;
    float: left;
    box-shadow: 0 2px 8px #00000026;
    margin-bottom: 10px;
    overflow: hidden;
    height: 120px;

    div {
      text-align: left;
      color: #333;
      font-size: 18px;
      padding-top: 20px;
      padding-left: 20px;
    }

    p {
      font-size: 24px;
      padding-top: 5px;
      font-weight: bold;
    }
  }
}

.copy-icon {
  height: 100px;
  border-radius: 5px;
  cursor: pointer;
}

.rowOperate {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .actionItem {
    margin-left: 10px;
    color: #597ef7;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}

.filterCondition {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  span {
    margin-left: 20px;
  }

  // .createBtn {
  //   margin-left: 20px;
  // }
}

.tags-container {
  padding: 16px 0px;
  overflow: hidden;
}

.tags-container .ad-tag {
  float: left;
  margin-left: 16px;
}

.tags-container .ad-tag:first-child {
  margin-left: 0;
}

.tags-container .inbl {
  display: inline-block;
  vertical-align: middle;
}

.tags-container .roi-input {
  position: relative;
  top: 1px;
}

.tags-container .roi-target-box {
  display: inline-block;
  margin-left: 24px;
}

.tags-container .info-item {
  float: left;
  height: 26px;
  //  margin-left:24px;
  position: relative;
  display: flex;
}

.avatar {
  widows: 26px;
  height: 26px;
  border-radius: 50%;
  margin-right: 5px;
}

.tags-container .info-item.editable {
  padding-right: 28px;
}

.tags-container .info-item .content {
  display: inline-block;
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-container .info-item .content .nobid-bid-content {
  color: #999;
}

.tag {
  background: #f2f2f2;
  border-radius: 4px;
  color: #999;
  font-size: 14px;
  line-height: 22px;
  padding: 2px 8px;
}

.tag.red {
  background: #fff1ef;
  color: #e5453f;
}

.tag.gray {
  background: #f2f2f2;
  color: #999;
}

.tag.green {
  background: #e6f8ee;
  color: #34ba7b;
}

.copynum {
  font-weight: bold;
  color: red;
}

.product-item {
  display: flex;
  height: 56px;
  margin-top: 8px;
}

.product-item .good {
  padding-left: 0;
}

.product-item .icon {
  border-radius: 4px;
  height: 56px;
  width: 56px;
}

.product-item .info {
  padding-top: 3px;
}

.product-item .info .name {
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  margin: 0 0 8px 16px;
}

.product-item .info .id,
.product-item .info .price {
  color: #999;
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  padding: 0 16px;
}

.product-item .info .separator {
  border-right: 1px solid #999;
  display: inline-block;
  height: 8px;
  position: relative;
}

.product-item .info .price-num {
  color: #333;
  margin-left: 8px;
}

.ad-drawer__aweme-info {
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 16px;
}

.title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  line-height: 34px;
}

.board-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 21px;
  min-width: 932px;

  .overview-board {
    background: #f2f2f2;
    background-color: #f2f2f2;
    margin: 0 10px 10px 0;
    border-radius: 8px;
    cursor: pointer;
    height: 108px;
    width: 175px;

    .inner {
      border-radius: 4px;
      padding: 12px 12px 17px;

      .metric {
        color: #252729;
        font-size: 14px;
        font-weight: 600;
        height: 20px;
        line-height: 20px;
        margin: 0;
      }

      .value {
        font-size: 20px;
        margin-top: 8px;
        font-weight: bold;
        color: rgb(51, 51, 51);
      }
    }
  }
}

.setting-item {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  min-height: 44px;
  padding: 12px 16px;
  width: 50%;
  float: left;

  label {
    color: #333;
    flex-shrink: 0;
    font-weight: bold;
    margin-right: 24px;
    width: 80px;
  }

  .display-value {
    color: #333;
    flex: 1 1;
  }
}

.footer {
  position: fixed;
  bottom: 0px;
  background: #fff;
  height: 80px;
  width: 940px;
  line-height: 80px;
  border-top: 1px solid #eee;

  button {
    margin-right: 10px;
  }
}

.videoimg {
  width: 70px;
  height: 70px;
  border-radius: 3px;
  cursor: pointer;
}

.dialog-left {
  width: 180px;
  float: left;
  padding-top: 20px;
  height: 100%;
  border-right: 1px solid #e5e5e5;
}

.dialog-left ul li {
  margin: 0 auto;
  line-height: 40px;
  font-size: 16px;
  color: #2d3035;
  width: 130px;
  height: 40px;
  border-radius: 3px;
  margin-bottom: 10px;
  text-align: left;
  cursor: pointer;
}

.dialog-center {
  width: 630px;
  float: left;
  padding: 10px 20px;
  color: #242a37;

  ul {
    padding: 0;
    margin: 0;
  }
}

.dialog-right {
  width: 190px;
  float: left;
  padding: 10px;
  color: #939cc0;
  height: 365px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-track-color: transparent;
  -ms-scrollbar-track-color: transparent;
  scrollbar-width: thin;
  border-left: 1px solid #e5e5e5;
}

.dialog-center-title {
  font-size: 16px;
  margin-bottom: 10px;
}

li {
  list-style: none;
}

.dialog-right ul li {
  margin: 0 auto;
  line-height: 30px;
  font-size: 14px;
  color: #13151a;
  width: 184;
  height: 30px;
  border-radius: 3px;
  margin-bottom: 10px;
  text-align: left;
  padding-left: 10px;
  cursor: pointer;
  background: #f2f2f2;
  position: relative;
}

.dialog-right ul li span {
  float: right;
  margin-right: 10px;
}

.dialog-center ul li {
  width: 25%;
  margin-bottom: 10px;
  float: left;
}

.dialog-right ul {
  margin: 0;
  padding: 0;
}

.yAxis {
  display: flex;
  align-items: center;
  justify-content: center;

  input {
    width: 145px;
    // background: #F2F2F2;
    border-radius: 5px;
    // border: none;
  }

  & > div {
    display: flex;
    align-items: center;
  }

  section {
    width: 13px;
    height: 12px;
    background: #ff4d4f;
    border-radius: 3px;
    margin-right: 10px;
  }

  & > div:nth-child(1) {
    margin-right: 35px;

    section {
      background-color: #1890ff;
    }
  }
}

.yAxis + .totops {
  height: 0;
  opacity: 0;
}

/* 在你的CSS文件或<style>标签中添加以下样式 */
/deep/ .ant-table-tbody > tr > td {
  padding: 8px;
  /* 修改单元格间距为10px */
}

/deep/ .ant-table-thead > tr > th {
  padding: 8px;
  /* 修改单元格间距为10px */
}

// css

.ant-card {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03),
    0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  list-style: none;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  position: relative;
  background: #ffffff;
  border-radius: 8px;
  border-top: 1px solid #efefef;
}

.acss-14lc1cu {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.acss-1fpsglh {
  margin-top: 8px;
  padding-top: 9px;
  border-top: 1px solid rgba(5, 5, 5, 0.06);
}

.acss-grxbm {
  position: relative;
  width: 100%;
  margin-bottom: 12px;
}

.acss-eji7bv {
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}

.acss-1x0bxe0 {
  font-size: 14px;
  line-height: 22px;
}

.acss-72p16p {
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.88);
}

.acss-qdes8r {
  position: relative;
  top: 4px;
  float: left;
  margin-right: 20px;
}

.acss-1odwksc {
  float: left;
}

.acss-1qoci3j {
  height: 22px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 22px;
}

.acss-18kfphl {
  position: absolute;
  top: 4px;
  right: 0;
  line-height: 1;
  cursor: pointer;
}

.acss-f1zikh {
  height: 38px;
  margin-top: 4px;
  margin-bottom: 0;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.88);
  font-size: 30px;
  line-height: 38px;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
}

.acss-16mkun2 {
  margin-top: 10px;
}

.oc-detail-bar {
  align-items: center;
  background: #f8f8f9;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 2px 16px;
}

.oc-detail-bar .oc-detail-bar-text {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  line-height: 48px;
  margin-bottom: -4px;
  margin-right: -32px;
}

.oc-detail-bar .oc-detail-bar-text .oc-detail-bar-config-item {
  display: flex;
  margin-bottom: 4px;
  margin-right: 62px;
  font-weight: 700;
}

.config-card-container .config-card {
  margin-bottom: 16px;
}

.oc-promotion-detail-card .oc-promotion-detail-card-header {
  align-items: center;
  background: #f8f8f9;
  border-radius: 8px;
  display: flex;
  height: 48px;
  justify-content: space-between;
  padding: 0 16px;
  font-weight: 700;
}

.oc-promotion-detail-card .oc-promotion-detail-card-body {
  margin-top: 8px;
}

.oc-promotion-detail-card
  .oc-promotion-detail-card-body
  .oc-promotion-detail-card-body-item {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 16px;
}

.oc-promotion-detail-card-body-item {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 16px;
}
.btn {
  margin-left: 20px;
}

.product-info {
  display: flex;
  padding-left: 20px;
  align-items: flex-start;
}

.product-left {
  flex-shrink: 0;
  margin-right: 12px;
}

.product-right {
  text-align: left;
  flex: 1;
  min-width: 0;

  .product-title {
    color: #323335;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 180px;
    font-weight: 500;
    margin-bottom: 4px;
  }

  .product-id {
    margin-bottom: 2px;
    color: #666;
    
    .anticon {
      color: #1890ff;
      
      &:hover {
        color: #40a9ff;
      }
    }
  }
}

// 补商品抽屉样式
.searchWapper {
  margin-bottom: 20px;
}

.goodsInfoWapper {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.goodImg {
  border-radius: 4px;
  height: 86px;
  width: 86px;
}

.goodRight {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: 10px;
  width: 250px;
  
  .goodTitle {
    font-size: 12px;
    font-weight: bold;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -moz-box;
    -moz-line-clamp: 2;
    overflow-wrap: break-word;
    word-break: break-all;
    white-space: normal;
    overflow: hidden;
  }
  
  .goodId {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 8px;
  }
}

.errtip {
  color: red;
  font-size: 10px;
  line-height: 15px;
  display: block;
}

// 筛选弹窗样式
.filter-container {
  .filter-section {
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    overflow: hidden;

    .filter-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      background-color: #fafafa;
      cursor: pointer;
      border-bottom: 1px solid #e8e8e8;

      .filter-title {
        font-weight: 500;
        color: #333;
      }
    }

    .filter-content {
      padding: 16px;

      .range-options {
        margin-bottom: 16px;

        .range-option {
          display: inline-block;
          padding: 6px 12px;
          margin: 4px;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          transition: all 0.3s;

          &:hover {
            border-color: #1890ff;
            color: #1890ff;
          }

          &.active {
            background-color: #1890ff;
            border-color: #1890ff;
            color: white;
          }
        }
      }

      .custom-range {
        .custom-inputs {
          display: flex;
          align-items: center;
          gap: 8px;

          .separator {
            color: #666;
            font-weight: 500;
          }
        }
      }
    }
  }

  .filter-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e8e8e8;
  }
}

// 裂变策略弹窗样式
.fissionStrategyModal {
  .ant-modal-body {
    padding: 10px 24px;
  }
  .confBlock {
    background: #fff;
    margin-bottom: 12px;
    border-radius: 4px;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.2);
    padding: 16px 24px;
    .cofBlockName {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      &::before {
        content: '';
        width: 4px;
        height: 14px;
        background-color: #2b6afd;
        margin-right: 8px;
        display: inline-block;
      }
    }
    .confContent {
      margin-top: 20px;
    }
    .confLine {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 10px;
      &.fxStart {
        align-items: flex-start;
        .confLable {
          margin-top: 6px;
        }
      }
      .confLable {
        width: 90px;
        text-align: right;
        margin: 0px 10px 0 0;
      }
      .confLineC {
        flex: 1;
      }
    }
  }
  // 裂变策略网格样式
  .fission-strategy-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, auto);
    gap: 16px;
    width: 100%;
    max-width: 800px;

    .strategy-item {
      background: #f8f9fa;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      padding: 16px;
      transition: all 0.3s ease;
      position: relative;
      min-height: 120px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      &:hover {
        border-color: #1890ff;
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
      }

      .strategy-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 8px;

        .strategy-title {
          margin: 0;
          font-size: 14px;
          font-weight: 600;
          color: #262626;
          line-height: 1.4;
          flex: 1;
          margin-right: 8px;
        }
      }

      .strategy-desc {
        margin: 0;
        font-size: 12px;
        color: #8c8c8c;
        line-height: 1.5;
        flex: 1;
      }
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    .fission-strategy-grid {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(4, auto);
    }
  }
}

.roi-popover-last-modify-line {
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
}
.roi-popover-last-modify-loading {
  margin-left: 6px;
  color: rgba(0, 0, 0, 0.45);
}
.roi-popover-last-modify--ok {
  color: #52c41a;
  font-weight: bold;
}
.roi-popover-last-modify--warn,
.roi-popover-last-modify--error {
  color: #f5222d;
}
</style>
